export default {
  id: "ID",
  dashboard: "Panel de control",
  warning: "Advertencia",
  users: "Usuarios",
  farms: "Granjas",
  animals: "Animales",
  action: "Acción",
  actionList: "Lista de acciones",
  drugInventory: "Existencias de medicamentos",
  inseminatorStatistics: "Datos estadísticos del inseminador",
  organizationNTR: "Organización NTR",
  genotypePerformance: "Genotipo Rendimiento",
  semenAutomation: "Automatización de semen",
  activityLogs: "Registro de actividad",
  username: "Nombre de usuario",
  title: "Título",
  deactivated: "Desactivado",
  name: "Nombre",
  email: "Correo electrónico",
  emailAddress: "Correo electrónico",
  mobileNum: "Número de móvil",
  emailOrMobile:"Correo electrónico/Móvil",
  role: "Función",
  pages: "Paginas",
  roles: "Funciones",
  department: "Departamento",
  status: "Estado",
  departments: "Desactivados",
  cancel: "Cancelar",
  submit: "Enviar",
  error: "error",
  success: "éxito",
  password: "Contraseña",
  Browse: "Examinar",
  orDropYourFileCsvXlsXlsxHere: "o suelte su archivo (CSV, XLS, XLSx) aquí",
  search: "Búsqueda",
  apply: "Aplicar",
  select: "Seleccionar",
  previous: "Previous",
  mandatory: "Obligatorio",
  dropYourFileHere:
    "o suelte su archivo (CSV, XLS, XLSx, PDF, Docx, PNG, JPEG) aquí",
  restoreDefault: "Restaurar predeterminada",
  pending: "Pendiente",
  completed: "Completado",
  remove: "Remover",
  update: "Actualizar",
  removeFile: "Remover archivo",
  uploadFile: "Subir archivo",
  pleaseChoosePreferedLanguage: "Por favor elige tu idioma preferido",
  edit: "Editar",
  activate: "Activar",
  deactivate: "Desactivar",
  recievedOrders: "Recieved Orders",
  chartRepresentation: "Representación gráfica",
  nameIsRequired: "Se requiere el nombre",
  export: "Exportar",
  noFilesAvailable: "NINGÚN ARCHIVO DISPONIBLE",
  selectDepartmentToshowRoles:
    "Seleccionar un departamento para enseñar los puestos",
  selectDepartmentWithActiveRoles:
    "Seleccionar un departamento con roles activos",
  nameCanContainOnlyAlphabets: "El nombre puede solo contener letras",
  nameMustBeLessThan15Chars: "El nombre debe tener menos de 30 caracteres",
  emailRequired: "Se requiere correo electrónico",
  invalidEmailFormat: "Formato inválido de correo electrónico",
  mobNumReq: "Se requiere número de teléfono móvil",
  invalidMobFormat: "Formato inválido de número de teléfono móvil.",
  passwordRequired: "Se requiere la contraseña",
  departmentReq: "Se requiere el departamento",
  roleReq: "Se requiere el puesto",
  unableToUpdate: "No se puede actualizar",
  orignalName: "Nombre original",
  uploadedDate: "Fecha de carga",
  fileName: "Nombre del archivo",
  importNum: "Número de importación",
  languagePreferences: "preferencia de idioma",
  pleaseTryAgainAfterSometime: "Por favor intente después de algún tiempo",
  noChanges: "Sin cambios",
  nothingchanged: "Nada ha cambiado",
  pleaseChooseAnImageFile: "Por favor elige un archivo de imagen",
  fileIsTooBigSelectUnder1MB:
    "¡Tu archivo es demasiado grande! Seleccione una imagen de menos de 1 MB",
  phoneShouldHave10Chars: "Teléfono debe tener 10 caracteres",
  onlyCSVAllowed: "Solo se permite archivo CSV",
  loadingPleaseWait: "Cargando... Espere.",
  manager: "Gerente",
  administrator: "administrador",
  Comingsoon: "Disponible en breve",
  totalAnimals: "Total de animales",
  receivedOrders: "Received Orders",
  drugs: "Medicamentos",
  detailedAnalysis: "Detailed Analysis",
  barGraphRepOfActiveUsersAndDeactivateUsers:
    "Representación gráfica de barras de usuarios activos y usuarios inactivos",
  barGraphRepOfRegAnimalsVsFarm:
    "Representación gráfica de barras de animales registrados frente a granja",
  roleNumber: "No. de la función",
  roleName: "Nombre de la función",
  active: "Activo",
  inactive: "Inactivo",
  admin: "Admin",
  addRole: "Añadir funciones",
  addRoles: "Añadir funcione",
  permissions: "Permiso",
  sr: "Sr.",
  moduleName: "Nombre del módulo",
  view: "Vista",
  deptNo: "No. del departamento",
  selectByCategory: "Seleccionar por categoría",
  weeklyAnalytics: "Análisis semanal",
  pregnancy: "El embarazo",
  analytics: "Analítica",
  calendar: "Calendario",
  productName: "Nombre del producto",
  volumeSold: "Volume Sold",
  recordPoints: "Record Points",
  inStock: "En existencia",
  revenue: "Revenue",
  stockStatus: "Condición de la existencia",
  barChart: "Gráfico de barras",
  lineChart: "Gráfico de linea",
  indexReturns: "Devoluciones del índice",
  chart: "Cuadro",
  time: "Tiempo",
  production: "producción",
  customization: "Personalización",
  recordsPerPage: "Registros por página",
  noDataAvailable: "Ningún dato disponible",
  reporting: "Informes",
  optional: "Opcional",
  note: "Nota",
  notes: "Detalles de vacunación/Notas",
  date: "Date",

  kG: "KG",
  weight: "Peso",
  type: "Tipo",
  lessthan3Month: "<3 Month",
  lessthan6Month: "<6 Month",
  lessthan7Month: "<7 Month",
  lastWeek: "La semana pasada",
  thisWeek: "Esta semana",
  lessthanOneYear: "<1 Years",
  lessthanTwoYear: "<2 Years",
  lessthanThreeYear: "<3 Years",
  lessthanFourYear: "<4 Years",
  yes: "Sí",
  no: "No",
  of: "de",
  notSpecified: "No especificada",
  days: "días",
  day: "día",
  aDay: "un día",
  years: "años",
  year: "año",
  unit: "unidad",
  units: "unidades",
  Unit: "Unidad",
  to: "a",
  profile: "Perfil",
  logOut: "cierre de sesión",
  otherSettings:"Otros ajustes",

  somethingWentWrong: "Algo salió mal.",
  toDo: "Hacer",
  loadingData: "Cargando datos...",
  taskNumber: "Número de la tarea",
  taskName: "Nombre de la tarea",
  startDate: "Fecha de inicio",
  dueDate: "Plazo previsto",
  reason: "Razón",
  quantity: "Cantidad",
  cost: "Costo",
  noRecordFound: "Ningún registro encontrado",
  dailyUpdates: "Actualizaciones diarias",
  weeklyUpdates: "Actualizaciones semanales",
  moduleAccessed: "Módulo accedido",
  typesOfAccess: "Tipos de Acceso",
  userId: "Id de Userio",
  lastLogin: "Último inicio de sesión",
  terminalID: "ID terminal",
  geographicalAccessPoint: "Punto de acceso geográfico",
  iPAddress: "Dirección de IP",
  fileAccessed: "File Accessed",
  functionAccessed: "Archivo accedido",
  webPageURL: "URL de la página web",
  accessType: "Tipo de acceso",
  unsuccessfulLoginAttempts: "Intentos de inicio de sesión sin éxito",
  customerAddress: "Dirección del cliente",
  orderdate: "Fecha del pedido",
  postageDate: "Fecha de envío",
  postID: "ID de correo",
  packingTechnician: "Técnica de embalaje",
  packingTechnicia: "Técnico de envase",
  packEdit: "Editar paquete",
  batchNumber: "Número del lote",
  collectionTechnician: "Técnico de colección",
  collectionTechnicia: "Técnico de colección",
  preparationTechnicia: "Preparation Technicia",
  preparationTechnician: "Preparation Technician",
  approvedManually: "Aprobado manualmente",
  researcher: "Investigador",
  dateOfApproval: "Fecha de aprobación",
  approvalEdit: "Aprobación editar",
  searchByAllExceptDate: "Buscar por todo excepto por fecha",
  approval: "Aprobación",
  collection: "Colección",
  postage: "Gastos de envío",
  pack: "Embalar",
  straws: "Pajita",
  createdAt: "Created At",
  sireID: "ID del padre",
  economicIndexValue: "Valor del índice económico",
  latestCollectionDate: "Fecha de la última colección",

  locationId: "ID de la ubicación",

  lastUpdated: "Última actualización",

  print: "Imprimir",
  save: "Ahorrar",
  tax: "Impuesto",
  phoneNo: "Telefono no",
  exportAsPDF: "Exportar como PDF",

  statusUpdated: "Status Updated",
  statusNotUpdated: "Status Not Updated",

  inProgress: "En progreso",
  assignedTo: "Asignado a",
  taskId: "identificación de la tarea",
  createdDate: "Created date",
  numberOfAnimals: "Número de animales",
  healthRecordSubmittedSuccess: "Registro de salud enviado con éxito",
  healthRecordSubmitted: "Registro de salud presentado.",
  InseminationRecordSubmittedSuccesful:
    "Registro de inseminación enviado con éxito",
  inseminationRecordSubmitted: "Registro de inseminación enviado.",
  actionListDailyTask: "Lista de acciones - Tarea diaria",
  sinceLastYear: "Desde el año pasado",
  sinceLastQuarter: "Desde el último trimestre",
  sinceLastMonth: "Desde el mes pasado",
  sinceLastWeek: "Desde la semana pasada",
  drugWithdrawPeriod: "Período de Retiro de Drogas",
  diagnosisName: "Nombre del diagnóstico",
  animalWithNoGenetype:
    "Este animal no tiene ningún dato de Genotipo registrado. Haga clic en el botón de abajo para registrarse.",
  nameOfPreviousOwner: "Nombre del dueño anterior",
  avatarSize: "¡El tamaño del avatar debe ser inferior a 1 MB!",
  testDestination: "Destino de prueba",
  animalNotAdded: "Animal no agregado",
  registerationSuccessful: "Registro exitoso",
  backToAnimalList: "Volver a la lista de animales",
  addAnotherAnimal: "Añadir otro animal",
  animalDetailsUpdated: "Detalles de animales actualizados con éxito",
  animalUpdatedSuccessfully: "Animal actualizado con éxito",
  animalNotUpdated: "Animal no actualizado",
  notMember: "¿No es un miembro?",
  requestAccess: "Solicitar acceso",
  typePassword: "Por favor, escriba la contraseña.",
  minChars: "Mínimo 6 caracteres",
  typeConfirmPassword: "escriba confirmar contraseña",
  passConfig: "La confirmación de la contraseña no coincide.",
  invalidEmailMobile: "Formato de correo electrónico/móvil no válido",
  passwordNotEmpty: "La contraseña no puede estar vacía",
  passwordLength:
    "La longitud de la contraseña no puede ser inferior a 8 caracteres",
  cityVillage: "Ciudad / Pueblo",
  districtRegion: "Distrito, región",
  alreadyHaveAnAccount: "¿Ya tienes una cuenta?",
  genetypeUpdated: "Genotipo actualizado",
  genetypeNotUpdated: "Genotipo no actualizado",
  sellTrade: "Vender/Comerciar",
  milkingDevon: "Ordeño Devon reproductores para la venta",
  detailedDescription: "Descripción detallada",
  longPara:
    "Novillas y vacas American Milking Devon Bulls. Todas son purasangres registrados. nuestros animales están bien socializados, y criado solo con pasto, heno y mucho amor. Estas hermosas Los animales son una rara raza de triple propósito para leche, carne obueyes Existencias A-1-A2 y A-2A-A2 disponibles. Por favor llame o envíe un correo electrónico para obtener más información o para concertar una visita al rebaño",
  contactSeller: "Contacte al vendedor",
  enterListingTitle: "Ingrese el título de la lista",
  livestocktype: "Tipo de ganado",
  uploadImage: "Subir una imagen",
  mobilePhone: "Número de teléfono móvil",
  myLivestock: "mi ganado",
  livestockObservations: "Observaciones de ganado",
  selectFromRegisteredAnimals:
    "Seleccionar de la lista de animales registrados",
  selectOption: "Seleccionar opción",
  selectTypeObservation: "Seleccionar tipo de observación",
  attachVeteinaryDocument: "Attach Veterinary Document",
  addsensorReading: "Agregar lectura del sensor",
  myDocument: "Mis documentos",
  enterAKeyword: "Introduzca una palabra clave",
  documentType: "Tipo de Documento",
  registerEditLivestock: "Registrar/Editar Ganado",
  editLivestockProfile: "Editar perfil de ganado",
  copy: "Copiar",
  dateOfRegister: "Fecha de registro",
  livestockType: "Tipo de ganado",
  registerNewLivestock: "Registrar Nuevo Ganado",
  enterUniqueTag: "Ingrese la etiqueta única #",
  color: "Color",
  gender: "Género",
  male: "Masculino",
  female: "Femenino",
  damm: "Presa #",
  siree: "Padre #",
  dateOfSaleAuction: "Fecha de venta/venta de subasta",
  auctionRecord: "Registro de subasta de Deathlist",
  distinguishingFeatures: "Características distintivas",
  keywordListing: "ID de palabra clave o listado",
  adType: "Tipo de anuncio",
  activeListingFund: "1 listado activo encontrado",
  setupSensors: "Configurar sensores",
  serialNumber: "Número de serie",
  sensorLocation: "Ubicación del sensor",
  sensorType: "Tipo de sensor",
  installationDate: "Fecha de instalación",
  ExpirationDate: "Fecha de caducidad",
  addGeo: "Añadir geolocalización",
  addMoreSensors: "Agregar más sensores",
  trackAndTrace: "Seguimiento y localización",
  createNewShipment: "Crear un nuevo envío",
  workflowReference: "Referencia de flujo de trabajo",
  invoiceDate: "Fecha de la factura",
  trackShipment: "Rastrear envio",
  totalShipments: "Envíos totales",
  activeShipment: "Envíos activos",
  completedObjectives: "Objetivos completados",
  processedPayments: "Pagos procesados",
  pointOfDestination: "Punto de destino",
  sellerInformation: "Información del vendedor",
  selectSellerConsignor: "Seleccionar vendedor/consignador",
  pointOfOrigin: "Punto de origen",
  buyerInfo: "Información del comprador",
  selectBuyerConsignor: "Seleccione Comprador/Remitente",
  addSensorTriggers: "Agregar disparadores de sensores",
  processPayments: "Procesar pagos",
  defineShippingContract: "Definir contrato de envío",
  addDigitize: "Agregar y digitalizar documentos",
  currentlyOnFarm: "Actualmente en la granja",
  addSire: "Agregar padre",
  addApproval: "Agregar aprobación",
  addCollection: "Agregar colección",
  addStraws: "Añadir pajitas",
  addPack: "Agregar paquete",
  addPostage: "Agregar franqueo",
  searchBySire: "Buscar por padre",
  anyDataChangeMightBeLost: "Cualquier cambio de datos podría perderse",
  wouldYouLikeToSaveOrWantToLeaveWithoutSaving:
    "¿Te gustaría ahorrar o te quieres ir sin guardar",
  leave: "Dejar",
  stay: "Permanecer",
  animalFarm: "Granja de animales",
  animalFarmH: "Granja de animales",
  animalOrigin: "Origen animal",
  animalOriginH: "Origen animal",
  farmOfOrigin: "Finca De Origen",
  farmOfOriginH: "Finca De Origen",
  selectFarm: "Seleccione Granja",
  searchFarm: "Seleccione Granja",
  confirmation: "Confirmación",
  proceed: "Proceder",
  ok: "DE ACUERDO",
  animal: {
    tagH: "Etiqueta",
    tagNumberH:
      "Número de etiqueta: puede agregar color y número. No se limita solo a números.",
    goveRegNoH:
      "Detalles de identificación que pueden incluir el nombre y la dirección del individuo, el agente del individuo para el servicio del proceso, la ubicación de la actividad a realizar y una descripción del servicio que brinda el individuo.",
    birthWeightH: "Peso al nacer del ternero",
    birthEaseH:
      "El parto en el ganado es un proceso natural, pero a veces puede haber problemas de parto en los que la madre necesita la asistencia del agricultor/pastoral.",
    birthFarmH: "Granja de nacimiento donde nació el animal",
    surrogateDamH:
      "Si el animal nació a través de transferencia de embriones. Esta es la identificación de la madre portadora/una hembra que se preña (como por transferencia de embriones o inseminación artificial) para tener crías en lugar de otro animal.",
    ownerH: "Este es el nombre del dueño del animal.",
    damH: "Número de identificación o registro de la madre del animal: la madre de un animal. En caso de transferencia de embriones, también es la identificación de la madre que donó un embrión para la transferencia de embriones.",
    sireH:
      "Una identificación o número de registro del progenitor masculino de un animal, especialmente un toro mantenido para reproducción o semen de toros utilizado para inseminación artificial.",
    breedH: "Esta es una raza del animal.",
    conceptionMethodH: "Cómo fue concebido el animal.",
    genderH: "Género del animal.",
    dobH: "Fecha de nacimiento del animal.",
    operatorH:
      "El nombre de la persona que completa la información de este animal.",
    removalFarmH: "Granja eliminada de animales",
    dateOfRemovalH: "Fecha de retiro del animal",
    destinationOfRemoval: "Lugar de destino del animal retirado",
    reasonOfRemovalH: "Motivo de la eliminación de animales",
    trackingNumberH: "Número asignado al animal cuando se retira el animal",
    brandH:
      "Marca: simplemente una marca permanente que se quemaba en la vaca.",
    tattoH: "Tatuaje en animal.",
    hornStatusH: "Si el animal está descornado.",
    animalOriginH: "El país de origen del animal.",
    previousOwnerH:
      "Nombre del dueño anterior del animal en caso de que sea adulto.",
    twinH: "Este campo dice si el animal tiene un gemelo o no.",
    regBreedAssoNoH: "Registro en Asociaciones/Sociedades de raza.",
    breedAssoNameH:
      "Nombre de las Asociaciones/Sociedades donde estuvo registrado el animal",
    breederH: "Este es el nombre de la organización que suministró el animal.",
    breeder: "Criadora",
    noteH: "Nota(s) importante(s) sobre el animal.",

    accuracyWeight_for_field: "Precisión Peso",
    conception: "Concepción",

    addAnAnimal: "Añadir un animal",
    addAnimal: "Añadir animal",
    registerAnAnimal: "Registrar un animal",
    uploadAnAnimal: "Cargando un animal",

    animalRegistration: "Registro del animal",
    animalDetails: "Detalles del animal",

    tag: "Etiqueta",
    tagNumber: "Número de la etiqueta",
    govtRegNumber: "Número de registro gob.",
    birthWeight: "Peso al nacer",
    birthEase: "Facilidad de nacimiento",
    birthFarm: "Granja de nacimiento",
    surrogateDam: "Madre portadora",
    owner: "Propietario",
    ownershipType: "Tipo de propiedad",

    govtReg: "Reg. Gob.",
    regDate: "Fecha reg.",

    dam: "Madre",
    sire: "Padre",
    heifer: "Novilla",
    steer: "Novillo",
    calf: "Becerro",
    farmHerd: "Granja/Rebaño",
    femaleCalf: "Ternero Hembra",
    maleCalf: "Ternero macho",
    newCalves: "Nuevos becerros",

    breed: "Raza",
    conceptionMethod: "Método de concepción",
    gender: "Género",
    dateOfBirth: "Fecha de nacimiento",
    operator: "Operador",
    animalRemovedFarm: "Animales retirados de la granja",
    dateOfAnimalRemoval: "Fecha del animal retirado",
    destinationOfRemovedAnimal: "Destino del animal retirado",
    reasonOfRemoval: "Razón de la remoción",
    optionalAnimalInformation: "Información opcional del animal",
    animalPicture: "Imagen del animal",
    trackingNumber: "Número de rastreo",
    brand: "Marca",
    tatto: "Tatuaje",
    hornStatus: "Estado del cuerno",
    animalOrigin: "Origen del animal",
    previosOwner: "Propietariao anterior",
    twin: "Mellizo",
    InABreedAssociation: "No. de registro en una asociación de raza",
    nameOfBreedAssociations: "Nombre de las asociaciones de razas",
    breedAssociations: "Nombre de las asociaciones de razas",
    breederSupplier: "Reproductor (proveedor)",
    importAnimal: "Importando un animal",
    loadingAnimals: "Cargando animales... Espere...",
    totalRegAnimals: "Total de animales registrados",
    totalPregnantAnimals: "Total de animales preñados",
    pregnantAnimalHistory: "Historia de animales preñados",
    dailyAnimalPregnancyUpdates: "Actualizaciones diarias de embarazo animal",
    animalHistory: "Historia de los animales",
    dailyAnimalUpdates: "Actualizaciones diarias de animales",
    totalPregnant: "Embarazo total",
    totalNewBorn: "Recién nacidos totales",

    searchByIDGOVRegTag: "Buscar por ID, registro y etiqueta de GOV",
    noANIMALAVAILABLE: "NO HAY ANIMALES DISPONIBLES",

    associationNumber: "Número de la asociación",
    associationName: "Nombre de la Asociación",

    destinationName: "Nombre de destino",

    plastic: "Plástico",
    metal: "Metal",
    naturalMating: "Apareamiento natural",
    artificialInsemination: "Inseminación artificial",
    embryoTransfer: "Transferencia de embriones",
    noAssistance: "Ninguna asistencia",
    someAssistance: "Cierta asistencia",
    mechanicalAssistance: "Asistencia mecánica",
    aCesareanSection: "Sección cesárea",
    abnormalDelivery: "Parto anormal",
    male: "Macho",
    female: "Hembra",
    sale: "Venta",
    slaughter: "Matadero",
    death: "Muerte",
    theft: "Robo",
    other: "Otro",
    horned: "Con cuernos",
    polled: "Sin cuernos",
    dehorned: "Descuernado",

    details: "Detalles",
    performance: "Rendimiento",
    geneticWorth: "Valor genético",
    healthRecord: "Registros de salud",
    genotypeData: "Datos de genotipo",
    reminders: "Recordatorios",
    activityLog: "Registro de actividad",
    activityLogDetails: "Detalles del registro de actividad",

    editAnimal: "Editar animal",

    familyInfo: "Información de la familia",
    breedInfo: "Información de raza",
    identification: "Identificación",
    removalInfo: "Información de remoción",

    iDOfAnimalDam: "ID de la madre del animal.",
    iDOfAnimalSire: "ID del padre del animal.",
    iDOfDamEmbryoUsed: "ID de la madre cuyos embriones se utilizaron.",
    animalHasATwinOrNot: "Si el animal tiene un mellizo o no.",

    breedType: "Tipo de raza",
    breedOfTheAnimal: "Esta es la raza del animal.",
    regBreedAssociations: "Registro en asociaciones/ sociedades de raza.",
    nameOfAssociationsSocieties:
      "Nombre de las asociaciones/ sociedades donde se registró el animal.",
    nameOfTheOrgSuppliedAnimal:
      "Este es el nombre de la organización que suministró el animal.",

    countryOriginAnimal: "País de origen del animal.",
    birthFarmID: "ID de la granja de nacimiento",
    farmIDAnimalBorn: "ID de la granja donde nació el animal .",
    currentOwner: "Propietario actual",
    nameOfOwnerAnimal: "Este es el nombre del propietario del animal.",
    registrationDate: "Fecha de registro",
    previousOwner: "Propietario anterior",
    nameOfOperator: "Fecha de registro",

    dateAnimalRemoved: "Fecha en que se eliminó el animal.",
    destinationPlaceRemovedAnimal: "Lugar de destino del animal eliminado",
    namePersonFillAnimalInformation:
      "El nombre de la persona que rellena esta información sobre el animal.",
    reasonOfAnimalRemoval: "La razón por la cual se eliminó el animal",
    reasonWhyTheAnimalIsRemoved: "La razón por la cual se eliminó el animal",
    processingDate: "Fecha de procesamiento",
    DateInformationFilledChanged:
      "Fecha cuándo se llenó o cambió la información actual.",

    animalID: "ID del animal",
    UniqueIdAnimal: "Este es el ID único del animal.",
    plasticTagNumber: "Número de la etiqueta de plástico",
    numberAnimalTag: "Número de la etiqueta del animal.",
    rFTagNumber: "Número de la etiqueta RF",
    numberAnimalRFTag: "Número de la etiqueta RF del animal.",
    govtRegNumb: "Número reg. gub.",
    govtRegistrationNumber: "Número de registro gubernamental.",
    numberAssignedAnimalIsRemoved: "Número asignado al animal al eliminarlo",
    dateOfAnimalRegistration: "Fecha de registro del animal",
    stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal:
      "La marca de existencias es un diseño que se quema en el cuero del animal, por ejemplo en el ganado vacuno para identificación del propietario de los animales. El color codifica un animal de acuerdo con una zona específica",
    tattoOnAnimal: "Tatuaje en el animal.",
    whetherTheAnimalIsDehorned: "Si se descornó el animal.",
    milkingAnimals: "Animales de ordeño",
    studAnimals: "animales sementales",
    animalInseminationRecord:
      "Informe sobre la salud (registro de inseminación animal) ",

    numOfStrawsOrdered: "Número de pajuelas ordenadas",
    totalNumOfStraws: "Número total de pajitas",
    strawId: "ID de la pajita",
    addSireAutomation: "Añadir automatización de padre",
    addApprovalAutomation: "Agregar automatización de aprobación",
    addCollectionAutomation: "Agregar automatización de colecciones",
    addStrawsAutomation: "Agregar automatización de pajuelas",
    addPackAutomation: "Agregar paquete de automatización",
    addPostageAutomation: "Agregar automatización de envío",
    searchBySire: "buscar por padre",
    numberOfProgenies: "Número de progenies",
    sireEdit: "Padre editar",
    searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId:
      "Búsqueda por ID de pajuela, Número total de pajuelas, Número de lote e ID de ubicación",
    searchByPackIdNumberOfStrawsOrderedPackingTechnicia:
      "Búsqueda por ID de paquete, número de pajuelas pedidas, técnico de empaque",
    searchByCollectionAndPreparationTechnicia:
      "Búsqueda por técnico de recogida y preparación",
    registerSemenAutomation: "Registrar Semen Automatización",
    addSemenAutomation: "Agregar automatización de semen",
    strawAutomationRegistered: "Automatización de paja registrada",
    strawAutomationRegisteredNotRegistered:
      "Straw Automation Registrado no registrado",
      sireAutomationRegistered: "Automatización de toros registrados",
      sireAutomationNotRegistered: "Sire Automation no registrado",
      postageAutomationIsRegistered: "La automatización del franqueo está registrada",
      postageAutomationNotRegistered: "Automatización de franqueo no registrada",
      packAutomationIsRegistered: "La automatización del paquete está registrada",
      packAutomationNotRegistered: "Pack Automatización No Registrada",
      postageAutomationIsUpdated: "Se actualiza la automatización de franqueo",
      postageAutomationNotUpdated: "Automatización de franqueo no actualizada",
      packAutomationIsUpadted: "La automatización del paquete se actualiza",
      packAutomationNotUpadted: "Paquete de automatización no actualizado",
      collectionAutomationUpdated: "Automatización de colecciones actualizada",
      collectionAutomationNotUpdated: "Automatización de colecciones no actualizada",
      approvalAutomationIsUpdated: "Se actualiza la automatización de aprobación",
      approvalAutomationIsNotUpdated: "La automatización de aprobación no está actualizada",
      collectionAutomationRegistered: "Automatización de cobranza registrada",
      collectionAutomationNotRegistered: "Automatización de cobranza no registrada",
      approvalAutomationIsRegistered: "La automatización de aprobación está registrada",
      approvalAutomationIsNotRegistered: "La automatización de aprobación no está registrada",
      strawAutomationUpdated: "Automatización de paja actualizada",
      strawAutomationIsNotUpdated: "Straw Automation no está actualizado",
    searchSire: "Buscar padre",
    strawsEdit: "Pajitas editar",
    nextAnimals: "siguiente animal",

    performanceInfo: {
      milk: "Leche",
      liveweight: "Peso vivo",
      score: "Puntuación",
      fertility: "Fertilidad",
      measurements: "Medidas",

      dailyProteinYield: "Rendimiento de proteína diaria",
      amountProteinMilkCowDay:
        "Cantidad de proteína en la leche obtenida de una vaca en un día en particular.",
      dailyMilkYield: "Rendimiento lácteo diario",
      volumeMilkCowDay:
        "Volumen de leche obtenido de una vaca en particular en un día en particular.",
      dailyFatYield: "Rendimento diario de grasa",
      amountFatMilkCowDay:
        "Cantidad de grasa en la leche obtenida de una vaca en un día en particular.",
      dailyProteinContent: "Contenido diario de proteína",
      dailyFatContent: "Contenido diario de grasa",
      milkLactose: "Leche con lactosa",
      amountLactoseMilk: "Cantidad de lactosa en la leche.",
      milkUrea: "Urea en la leche",
      indicatorAmountCrudeProtein:
        "Indicador de cantidad de proteína bruta en la dieta de la vaca",
      lactationNumber: "Número de lactancia",
      ordinalNumLactation: "Número ordinal de lactancia.",
      lengthOfLactation: "Duración de lactancia",
      milkingFrequency: "Frecuencia de ordeño",
      frequcnyOfMilking: "Frecuencia de ordeño.",
      lactationLength: "Duración de la lactancia (por ejemplo, 23 días)",

      liveWeightInformation: "Información de peso vivo",
      currentWeight: "Peso actual",
      weightAnimal: "Peso del animal.",
      postWeaningGain: "Ganancia de peso post-destete",
      dailyGainInAnimalWeightWeaning:
        "Ganancia diaria del peso del animal post-destete.",
      weaningWeight: "Peso destete",
      weightAnimalMeasuredWeaning: "Peso del animal en el día del destete .",
      averageDailyGain: "Ganancia media diaria",
      averageAmountWeightAnimalGainFeedingPeriod:
        "Cantidad media de peso que un animal ganará diariamente durante el periodo de alimentación",
      carcassWeight: "Peso en canal",
      weightAnimalsHideInternalOrgansRemoved:
        "Peso de los animales después que se han retirado la cabeza, cuero y órganos internos.",
      weightAtCalving: "Peso al parto",
      weightAtTheTimeOfCalving: "Peso en el momento del parto.",
      yearlingWeight: "Peso de un animal de un año",
      weightYearOldAnimal: "Peso de un animal de un año.",

      somaticCellScore: "Puntuación de células somáticas",
      somaticCellScoreIndicatorMastitis:
        "Puntuación de células somáticas como indicador de mastitis.",
      lastUpdate: "Última actualización",
      bodyConditionScore: "Puntuación de condición de cuerpo",
      scoreAnimalFat:
        "Puntuación del animal con respecto a la cantidad de grasa que tiene..",
      teatScore: "Puntuación de ubre",
      scoreMeasureingShapeTeats: "Puntuación de medida forma de la ubre.",
      udderScore: "Puntuación de ubre",
      scoreMeasureingShapeOfUdder: "Puntuación de medida forma de la ubre.",
      whetherAnimalEasyBirthDifficult:
        "Si el animal tuvo nacimiento fácil o difícil (necesitó ayuda al parto).",
      totalLongevity: "Longevidad total",
      survivalLactationTraitCowCulledBreeding:
        "Superviviencia de la primera a la quinta lactancia. Se calcula esta característica después que la vaca es sacrificada y si se necesita la estimación del valor genético..",
      docility: "Docilidad",
      circumferenceBullScrotal: "Circunferencia del escroto de toro",

      intervalSuccessInsemination:
        "Intervalo entre la primera y la inseminación exitosa.",
      ageAtFirstCalving: "Edad al primero parto",
      ageCowCalving: "Edad de la vaca a su primero parto.",
      calvingInterval: "Intervalo entre partos",
      periodCalving: "Periodo entre partos.",
      scrotalCircumference: "Circunferencia escrotal",
      estrusDetection: "Detección de estro",
      trackingBehaviorAnimalDetectingEstrus:
        "Comportamiento de movimiento de seguimiento del animal para detección de estro en vacas.",
      presenceOfEstrus: "Presencia de estro",
      isCowInEstrusStage: "Es cuando una vaca está en estro o ni",

      matureWeight: "Peso maduro",
      weightAnimalDefinedAge: "Peso del animal en edad definida.",
      matureHeight: "Alto maduro",
      heightAnimalDefinedAge: "Alto del animal en edad definida.",
      footClawSet: "Conjunto pie uña",
      shapeAnimalClaw: "Forma del pie del animal.",
      pulmonaryArterialPressure: "Presión arterial pulmonar",
      animalBloodPreasure: "Presión del animal.",
      footAngle: "Ángulo del pie",
      shapeAnimalFoot: "Forma del pie del animal.",
      ribEyeArea: "Area de bistec",
      amountRibEyeArea: "Cantidad de area de bistec.",
      ultrasoundFat: "Ultrasonido de la grasa",
      measureFatAmount: "Medida de la cantidad de grasa.",
      ultrasoundIntramuscularFat: "Ultrasonido de la grasa intramuscular",
      ultrasoundRibEyeArea: "Ultrasonido de la area de bistec",
      measureRibeyeArea: "Medida de la area de bistec.",
      fatThickness: "Espesor de la grasa",
      anmountAnimalBackFat: "Cantidad de grasa dorsal.",
      marbling: "Vetas de grasa",
      marballingMeasurement: "Medida de las vetas de grasa.",
      dryMatterIntake: "Ingesta de materia seca",
      amountFeedAnimalConsumesAMoisture:
        "Cantidad de alimento consumido por día por animal de base libre de humedad.",
    },

    feedsName: "Nombre del alimento",
    firstFeedQuantity: "Cantidad del primer alimento",
    additionalFeed: "Alimento adicional",
    cloversRyeGrasses: "Clovers, Rye grasses",
    greenFodderHayLegumes: "Green Fodder, Hay, Legumes",
    feedsRegisteredSuccessfully: "Pienso registrado correctamente",
    feedsNotRegistered: "No se han registrado los piensos",

    fEEDQUANTITY: "CANTIDAD DE ALIMENTACIÓN",
    feedQuantity: "CANTIDAD DE ALIMENTACIÓN",
    fEEDNAME: "NOMBRE DE LA COMIDA",
    feedName: "Nombre de la comida",
    nOFEEDINFOAVAILABLE: "NINGUNA INFORMACIÓN DE ALIMENTACIÓN DISPONIBLE",
    searchByFeedName: "Buscar por nombre de la comida",
    loadingFeedInfo: "Cargando información sobre la alimentación... Espere",
    todayFeedInfo: "Información sobre la comida de hoy",
    feedInfo: "Información de alimentación",
    loremIpsumDolorSitAmet:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut lacus sem, maximus vitae interdum in, consequat non sem. Morbi posuere dignissim est ut molestie.",

    geneticWorthInfo: {
      breedingValueEconomicIndex:
        "Si se utiliza este valor genético para el cálculo del índice económico.",
      dailyProteinYieldUsed: "Rendimiento diario de la proteina utilizada",
      weightAssignedBreedingDailyProteinYield:
        'Peso asignado al valor genético correspondiente para "rendimiento diario de proteína". Se utiliza este peso para el cálculo del índice económico.',
      dailyProteinYieldWeight: "Peso del rendimiento diario de proteína",
      rankAnimalInRelationshipEconomicIndex:
        "Clasificación del animal en relación con el índice económico.",
      economicIndexRank: "Clasificación del índice económico",
      percentileEconomicIndexFall: "Percentile which economic index falls in.",
      economicIndexPercentile: "Percentil del índice económico",
      accuracyOfEconomicIndex: "Precisión del índice económico.",
      economicIndexAccuracy: "Precisión del índice económico",
      weightedAverageOfBreedingValues:
        "Media ponderada de los valores de reproducción.",
      economicIndex: "Índice económico",
      rankOfAnimalInRelationshipBreeding:
        "Clasificación del animal en relación con el valor genético correspondiente.",
      dailyProteinYieldBreedingValueRank:
        "Clasificación de valor genético, rendimiento diario de proteína ",
      percentileBreedingFalls: "Percentil en el que cae el valor de cría.",
      dailyProteinYieldBreedingPercentile:
        "Percentil del valor genético del rendimiento diario de proteína",
      accuracyEstimatedBreeding:
        "Precisión del valor estimado de reproducción.",
      dailyProteinYieldBreedingAccuracy:
        "Precisión del valor de cría del rendimiento diario de proteína",
      estimatedBreedingTraitDailyProteinYield:
        'Valor estimado de reproducción de la característica "rendimiento diario de proteína".',
      dailyProteinYieldBreedingValue:
        "Valor de cría de rendimiento diario de proteína ",
      pathToTheDirectoryScriptsBreeding:
        "Ruta al directorio en el disco duro que contiene las secuencias de comandos que se utilizaron para el cálculo del valor genético.",
      scriptsPath: "Ruta de las secuencias de comandos",
      softwarePackageBreeding:
        "Paquete de programa que se utilizó para calcular el valor genético.",
      breedingValueSoftware: "Programa de valor genético",
      methodCalculateBreeding:
        "Método que se utilizó para el cálculo de valor genético",
      breedingValueMethod: "Método del valor genético",
      trait: "Característica",
      tools: "Herramientas",
      geneticWorth: "Valor genético",

      dailyProteinYield: "Rendimiento de proteína diaria",
      breedingValue: "Valor genético",
      breedingValueBIFAccuracy: "Precisión BIF del valor genético",
      breedingValuePercentile: "Breeding value percentile",
      breedingValueRank: "Percentil del valor genético",
      checkLTD: "Verificar LTD",
      ultrasoundDiagnostic: "Diagnóstico de ultrasonido",
      selectYieldUsed: "Seleccionar rendimiento utilizado",
      softwareName: "Software name",
      animalGenWorthUpdatedSuccessfully:
        "Se actualizó el Valor Gen del animal correctamente",
    },

    addNote: "Añadir nota",
    enterNote: "Ingresar nota",
    noteIsRequired: "Se requiere nota",
    noteMustBeLessThan50Characters: "Nota debe tener menos de 50 caracteres",
    noteAdded: "Se ha añadido la nota",
    noteNotAdded: "No se ha añadido la nota",
    noteForAnimal: "Nota para animal.",
    noNoteFoundForThisAnimal: "No se encontró ninguna nota para este animal.",

    inseminationData: "Fecha de inseminación",
    nameOfInseminator: "Nombre del inseminador",
    activity: "Actividad",
    searchByNameActivity: "Buscar por nombre, actividad",
    searchByTaskNameNumber: "Buscar por nombre de tarea, número",
    inseminationDate: "Fecha de inseminación",

    genotypeDataInfo: {
      genotypeAnimalID: "ID de animal de genotipo",
      iDTubeBloodSampleAnimalNumberGenotypingService:
        "Este es el ID de un tubo con muestra de sangre que se tomó de un animal o el número del servicio de genotipado",
      geneticTechnicianName: "Nombre del técnico genético",
      NameTechnicianBloodSamplesAnimal:
        "Este es el nombre del técnico que tomó las muestras de sangre del animal",
      sNPData: "Datos SNP",
      genotypingServiceNote: "Nota del servicio de genotipado",
      InfoGenotypingGenotypingTechnology:
        "Toda la información relacionada con el genotipado como nombre de la empresa, tecnología utilizada, fecha, etc. ",
      numberOfSNPs: "Número de los SNPs",
      numberOfSNPsAnimalGenotyped:
        "Número de los SNPs que se genotipó el animal",

      nameOfTheDrug: "Nombre del medicamento",
      animalGenoDataUpdatedSuccessfully:
        "Se han actualizado los datos geno del animal correctamente",
      animalGenoDataNotUpdated:
        "No se han actualizaso los datos geno del animal",
      animalIDIsRequired: "Se requiere el ID del animal",
      techNameIsRequired: "Se requiere el nombre del técnico",
      onlyAlphabetsAreAllowed: "Solo se permiten letras",
      genoDataIsRequired: "Se requiere datos geno",
      serviceNoteIsRequired: "Se requiere nota de servicio",
      sNPIsRequired: "Se requiere SNP",
    },

    healthRecordInfo: {
      treatment: "Tratamiento",
      treatmentTakenAnimal: "Qué tratamiento se adoptó para el animal.",
      reasonOfTreatment: "Razón del tratamiento",
      reasonForTreatment: "Razón del tratamiento",
      whatReasonOfTreatment: "Cuál es la razón del tratamiento.",
      treatmentDate: "Fecha de tratamiento",
      dateOfTreatment: "Fecha del tratamiento.",
      diagnosis: "Diagnóstico",
      nameDiagnosedDiseaseConditionSymptoms:
        "Nombre de la enfermedad diagnosticada/ condición o síntomas principales",
      drugID: "ID del medicamento",
      iDOfDrugWhichIsGivenToAnimal:
        "ID del medicamento que reciben los animales.",
      drugName: "Nombre del medicamento",
      nameDrugAnimal: "Nombre del medicamento que reciben los animales.",
      drugWithdrawalPeriod: "Periodo de retirada del fármaco",
      timeAdministrationDrugAnimalMeatMilkHumanConsumption:
        "Tiempo necesario después de la administración de un medicamento para garantizar la seguridad de la carne o de la leche para consumo humano",
      attendingVeterinarian: "Veterinario a cargo",
      qualifiedPersonCaseAnimal: "Persona calificada que vio el caso/ animal",
      packID: "ID del paquete",
      iDPackTreatment: "ID del paquete que se utilizó para el tratamiento",
      veterinarianName: "Nombre del veterinario",
      animalNoHealthRecord:
        "Este animal no tiene historia clínica. Haga clic en el botón para registrarla",
      addHealthRecord: "Añadir história clínica",
      healthStatus: "Health Status",
      loadingDiseasesPleaseWait: "Cargando Enfermedades... Por favor espere",
      animalDiseaseRecord: "Registro de enfermedades animales",
      animalHealthRecord: "registro de salud animal",
      animalTreatmentRecord: "registro de tratamiento del animal",
      loadingHealthData: "Loading Health Data...",
      healthRecord: "Registros de salud",
      nameOfDiagnosis: "Nombre del diagnóstico",
      treatmentName: "Nombre del tratamiento",
      drugGivenBy: "Medicamento dado por",
      recessiveDiseases: "Enfermedades Recesivas",
      recessiveDiseasesMessage:
        "¿De qué alelos recesivos de enfermedad es portador este toro?",
    },

    conceptionInfo: {
      addNewConception: "Añadir nueva concepción",
      semenEmbryo: "Semen/ embrión",
      pregnancyCheck: "Control de embarazo",
      birthInfo: "Información de nacimiento",
      searchByInseminatorOrganisationBreedingConception:
        "Buscar por nombre de inseminador, nombre de la organización, número del servicio de reproducción, método de concepción",

      deliveryDate: "Fecha de entrega",
      calfId: "ID del becerro",
      birthDayOldWeight: "Nacimiento (edad) peso",
      searchByBirthEase: "Buscar por facilidad de nacimiento",

      searchPregnancyCheckOperatorMethod:
        "Buscar por operador de control de embarazo, método de control de embarazo",
      pregnancyCheckDate: "Fecha de comprobación de embarazo",
      conceptionSuccess: "Éxito de concepción",
      pregnancyCheckOperator: "Operador de comprobación de embarazo",
      pregnancyCheckMethod: "Método de comprobación de embarazo",
      recentlyPregnant: "Recientemente embarazado",
      pregnancyConfirmationDate: "Fecha de confirmación del embarazo",
      pregnancyRate: "Tasa de embarazo",
      timePeriodOfPregnancy: "Período de tiempo del embarazo",
      semenProduction: "Producción de semen",
      embryoProduction: "Producción de embriones",
      semen: "semen",
      embryoTransferDate: "Fecha de  transferencia del embrión",
      daysOfPregnancy: "Días de embarazo",

      searchSireEmbryoSurrogate:
        "Buscar por ID del padre, nombre de la org. de embrión, de la madre de reproducción",

      selectDate: "Seleccionar fecha",
      orgnisationNameContainNumber:
        "Nombre de la organización no debe contener números",
      selectBirthEase: "Seleccionar facilidad de nacimiento",
      selectUnit: "Seleccione una unidad",
      animalConceptionAddedSuccessfully:
        "Se ha añadido concepción de animal correctamente",
      postageCustomerName: "Nombre del cliente de franqueo",
      searchByPostageCustNameCustAddPostId:
        "Buscar por franqueo Nombre del cliente, Dirección del cliente, ID de la publicación",
      dateOfSemenCollection: "Fecha de colección de semen",
      dateOfSemenPreparation: "Fecha de preparación de semen",
      semenMotility: "Motilidad del semen",
      semenConcentration: "Concentración del semen",
      postageEdit: "Franqueo Editar",
      enterSireId: "Ingresar ID del padre",
      selectEmbryoOrganisation: "Seleccionar Nombre Org. Embrión",
      matingDateH:
        "Fecha de concepción, ya sea monta natural o inseminación artificial.",
      inseminatorNameH:
        "Una persona que realiza el proceso de inseminación (veterinario/técnico)",
      orgNameH:
        "Nombre de la organización o empresa que proporciona la pajilla de semen para la IA",
      brServiceNumH:
        "Registro del número de crías (por ejemplo, 1.°, 2.° o 3.°)",
      conceptionMethodH:
        "La forma en que el animal concibe es el comienzo del embarazo, marcado por la fertilización de un óvulo por un espermatozoide.",

      customerAddress: "Dirección del cliente",
      sireIdH:
        "Una identificación o número de registro del progenitor masculino de un animal, especialmente un toro mantenido para reproducción o semen de toros utilizado para inseminación artificial.",
      damIdH:
        "Número de identificación o registro de la madre del animal: la madre de un animal. En caso de transferencia de embriones, también es la identificación de la madre que donó un embrión para la transferencia de embriones",
      sarogatedDamH:
        "Si el animal nació a través de transferencia de embriones. Esta es la identificación de la madre portadora/una hembra que se preña (como por transferencia de embriones o inseminación artificial) para tener crías en lugar de otro animal.",
      embOrgNameH: "El nombre de la organización para el embrión.",
      sarogateDamBreedH: "La fecha de la raza sustituta.",
      sireBreedH: "El tipo de la raza del padre (brahman, boran)",
      pregCheckDateH:
        "La preñez se puede detectar en vacas a los 30 días mediante ultrasonido y análisis de sangre. Para que las vacas se identifiquen como preñadas utilizando el método de palpación, las vacas a menudo necesitan tener al menos 35-50 días de preñez. Las ecografías se utilizan para el diagnóstico de embarazo a los 40 - 75 días de gestación.",
      conceptionSuccessH:
        " En el ganado bovino, la tasa de fecundación es del 90 % con una tasa media de partos de alrededor del 55 %, lo que indica una mortalidad embrionaria y fetal de alrededor del 35 % (Diskin et al., 2006). Además, del 70 al 80 % de la pérdida embrionaria total ocurre durante las primeras tres semanas después de la inseminación, particularmente entre los días 7 y 16.",
      pregnancyCheckOperatorH:
        "Los veterinarios y los técnicos especializados en animales suelen prestar estos servicios a los ganaderos. Ambos procedimientos son invasivos y los profesionales requieren una amplia capacitación para realizar el procedimiento de manera segura (para la vaca y el operador) con suficiente precisión y velocidad para que el servicio sea económicamente viable.",
      pregnancyCheckMethodH:
        "Los dos métodos más utilizados para el diagnóstico de preñez de bovinos son la palpación manual del tracto reproductivo (por recto) y la ecografía transrectal del tracto reproductivo.",
      deliveryDateH: "Fecha en que ocurre el parto",
      calfIdH: "Identificación del ternero recién nacido",
      birthEaseH:
        "El parto en el ganado es un proceso natural, pero a veces puede haber problemas de parto en los que la madre necesita la asistencia del agricultor/pastoral.",
      birthDayOldWeightH:
        "Peso de un animal el día del nacimiento o peso de un ave de un día",
    },
    all: "Toda",
    ungrouped: "Animales Desagrupados",
    active: "Animales Agrupados",
    updateAnimal: "Actualizar Animal",
  },
  dashboardS: {
    dailyActivities: "Actividades diarias",
    pendingTasks: "Tareas pendientes",
    performanceOfGeno: "Rendimiento de genotipos",
    breed: "Raza",
    chromosome: "Cromosoma",
    seqChange: "Cambio de sequencia",
    inheritance: "Herencia",
    diseaseName: "Nombre de la enfermedad",
    refSequence: "Referencia Pubmed",
    pubmedRef: "Referencia Pubmed",
    matingDate: "Fecha de apareamiento",
    inseminatorName: "Nombre del inseminador",
    orgName: "Nombre de la organización",
    brServiceNum: "Número del servicio de reproducción",
    conceptionMethod: "Método de concepción",
    semEmbInfo: "Información de semen/embrión",
    sireId: "ID del padre",
    damID: "Identificación de la presa",
    srgDamId: "ID de la madre portadora",
    embOrgName: "Nombre Org. Embrión",
    srgDamBreed: "Raza de la madre portadora",
    sireBreed: "Raza del padre",
    damBreed: "Raza de la madre",
  },
  user: {
    selectLanguage:"Seleccione el idioma",
    unitPreference:"Preferencia de unidad",
    selectUnitOfMeasure:"Seleccionar unidad de medida",
    importedUser: "Usuario importado",
    impFileStatus: "Estado del archivo importado",
    loadingUser: "Cargando usuarios... Por favor espere",
    totalUsers: "Total de usuarias",
    changePassword: "Cambiar la contraseña",
    goodIdeaToUsePassword:
      "Es una buena idea usar una contraseña segura que no estés usando en ningún otro lugar.",
    enterCurrentPassword: "Introducir la contraseña actual",
    enterNewPassword: "Ingrese nueva clave",
    enterPassword: "Ingrese nueva clave",
    phoneNum: "Número de teléfono",
    emailAddr: "Introducir la dirección de correo electrónico",
    enterYourPhoneNumber: "Ingrese su número telefónico",
    reEnterPassword: "Re-ingrese nueva contraseña",
    repeatNewPassword: "Repita la nueva contraseña",
    pleaseTypeOldPassword: "Por favor, escriba la contraseña anterior.",
    pleaseTypeNewPassword: "Por favor, escriba una nueva contraseña.",
    pleaseTypeConfirmPassword: "Por favor escriba confirmar contraseña.",
    passwordChangedSuccesFully: "Contraseña cambiada con éxito",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    passwordDoesNotMatch: "Las contraseñas no coinciden.",
    emailCanNotBeEmpty: "El correo electrónico no puede estar vacío",
    profileUpdated: "Perfil actualizado",
    profileNotUpdated: "Perfil no actualizado",
    unableToVerifyEmail: "No se puede verificar el correo electrónico",
    otpSentOnEmail: "OTP enviado por correo electrónico",
    otpSentSuccessFully: "OTP enviado con éxito",
    importUsers: "Importar usuarios",
    imageUpdated: "Imagen actualizada",
    departmentName: "Nombre del departamento",
    departmentNum: "Número de departamento",
    departmentAdded: "Departamento agregada",
    departmentNotAdded: "Departamento no agregado",
    addDepartment: "Añadir departamento",
    addNewDepartMent: "Añadir Nuevo Departamento",
    searchDepartnment: "Buscar Por Nombre O Número De Departamento",
    roleNameIsRequired: "Se requiere nombre del puesto",
    roleNameMustBeLessThan15Chars:
      "Nombre del puesto debe tener menos de 15 caracteres",
    roleAdded: "Puesto añadido",
    editDepartment: "Editar departamento",
    departmentUpdated: "Se ha actualizado el departamento",
    departmentNotUpdated: "No se ha actualizado el departamento",
    deleteDepartment: "Eliminar Departamento",
    deleteDepartmentMessage:
      "¿Está seguro de que desea eliminar este departamento?",
    noRoleAvailable: "Ninguna función disponible",
    roleUpdated: "Se ha actualizado el puesto",
    roleNotUpdated: "No se ha actualizado el puesto",
    editRole: "Editar función",
    allRole: "Todos los roles",
    addNewRole: "Agregar nuevo rol",
    allDepartment: "Todo el Departamento",
    permissionsUpdated: "Se han actualizado los permisos",
    permissionsnotUpdated: "No se han actualizado los permisos",
    roleNo: "No. de funciones.",
    searchByEmailAndName: "Buscar por correo electrónico y nombre",
    userID: "ID de usuario",
    userUpdated: "Usuario actualizado",
    userNotUpdated: "Usuario no actualizada",
    userAdded: "Usuario agregada",
    userNotAdded: "Usuario no agregado",
    activateUser: "Activar usuario",
    deactivateUser: "Desactivar usuario",
    userStatusMsg: "¿Está seguro de que desea cambiar el estado del usuario?",
    countryRequired: "El país es obligatorio",
    stateRequired: "Se requiere estado",
    cityRequired: "La ciudad es requerida",
    searchByRole: "Buscar por número de rol, nombre de rol, departamento",
    noModuleAvailable: "Ningún módulo disponible",
    searchBYModuleName: "Buscar por nombre de módulo",
  },
  farm: {
    farmID: "ID de la granja",
    onTheFarm: "En la granja",
    userRoles: "Funciones de usuario",
    adduser: "Añadir usuario",
    addAuser: "Añadir usuario",
    uploadUsers: "Cargar usuario",
    addNewUser: "Añadir nuevo usuario",
    selectDept: "Seleccionar departamento",
    selectRole: "Seleccionar función",
    editUser: "Editar usuario",
    NoAnimalsRegisteredForthisFarm:
      "No hay animales registrados para esta granja",
    farmsPerPage: "Granjas por página",
    regularFarms: "Granjas Regulares",
    totalFarms: "Granjas totales",

    farmRegisteredProducts: "Productos registrados de la granja",
    searchByFarmNameAndId: "Buscar por nombre de la granja e ID",
    loadingProductsPleaseWait: "Cargando productos... Espere",
    farmName: "Nombre de la granja",
    farmLocation: "Ubicación de la granja",
    productName: "Nombre del producto",
    stockStatus: "Condición de la existencia",
    inStock: "En existencia",
    searchByProductName: "Buscar por nombre de producto",
    productCategory: "Categoría de producto",
    products: "Productos",

    farms: "Granjas",
    registerAfarm: "Registrar uma granja",
    govtRegistry: "Registro del Gob.",
    cooperativeID: "ID de la cooperativa",
    farmType: "Tipo de granja",
    contractMating: "Apareamiento de contracto",
    customization: "Personalización",
    recordsPerpage: "Registros por página",
    restoreDefault: "Restaurar configuración predeterminada",
    apply: "Aplicar",
    searchState:
      "Buscar por ID de la granja, registro gub., ID de la cooperativa, tipo de granja, apareamiento de contrato",
    farmOwner: "Propietario de la granja",
    govRegistrationNo: "Número de registro del gobierno",
    farmInformation: "Información de la granja",
    ownershipType: "Tipo de propiedade",
    communityName: "Nombre de la comunidad",
    farmLicenseInformation: "Información de la licencia de la granja",
    licenseNumber: "Número de la licencia",
    licenseExpiryDate: "Fecha de expiración de la licencia",
    regulatorName: "Nombre del regulador",
    regulatorRepresentativeName: "Nombre del representante regulador",
    farmLocationSize: "Ubicación y tamaño de la granja",
    productionSystem: "Sistema de producción",
    country: "País",
    state: "Estado",
    city: "Ciudad",
    street: "Calle",
    houseNumber: "Número de la casa",
    farmRegistration: "Registro de la granja",
    cancel: "Cancelar",
    register: "Registro",
    ok: "ok",
    totalFarmSize: "Tamaño total de la granja",
    farmGeographicLocation: "Ubicación geográfica de la granja",
    perimeterPointLongitude: "Longitud del punto del perímetro",
    perimeterPointLatitude: "Latitud del punto del perímetro",
    perimeterPointLabel: "Etiqueta del punto del perímetro",
    perimeterLength: "Largo del perímetro",
    farmLatitude: "Latitud de la granja",
    farmLongitude: "Longitud de la granja",
    editFarm: "Editar granja",
    update: "Actualizar",
    editAfarm: "Editar una granja",
    nextFarm: "Siguiente Granja",
    nameoftheFarm: "Nombre de la granja",
    registerAProduct: " Registrar un producto",
    farmProducts: "Productos de la granja",
    calf: "Becerro",
    steer: "Novillo",
    heifer: "Novilla",
    sire: "Padre",
    dam: "Presa",
    registerAnAnimal: "Registrar un animal",
    farmAnimals: "Animales de la granja",
    farm_type: "Tipo de granja",
    farm_Owner: "Propietario de la granja",
    dateOfRegistration: "Fecha de registro",
    dataIsNotAvailableForThisFarm: "Data Is Not available for this Farm",
    registerNewProduct: "Register A New Product",
    information: "Información",
    licenseInfo: "Información de licencia",
    locationInfo: "Información de la ubicación",
    geoLocation: "Ubicación geográfica",
    perimeterLengthState:
      "Largo del perímetro de la granja (largo de la cerca)",
    totalFarmSizeState: "Tamaño de uma granja",
    productionSystemState: "Sistema de producción usado en la granja",
    contractMatingState:
      "Código del Programa de Apareamiento de Contracto en que la granja participa.",
    ownershipTypeState: "Tipo de propiedade",
    regulatorRepresentativeNameState:
      "Nombre de la persona que representa el regulador que ha liberado la licencia",
    regulatorNameState: "Nombre del regulador que ha liberado la licencia",
    licenseExpiryDateState: "Fecha de expiración de la licencia actual",
    licenseNumberState: "Número de licencia liberado por el regulador",
    plotNumberState: "Número de la casa de la granja.",
    plotNumber: "Número de la casa/ terreno",
    streetStatement: "Nombre de la calle de la granja",
    cityStatement: "Ciudad dónde se encuentra la granja.",
    stateStatement: "Región dónde se encuentra la granja.",
    countryState: "País dónde se encuentra la granja.",
    perimeterPointLongitudeState: "Longitud de un punto en la granja.",
    perimeterPointLatitudeState: "Latitud de un punto de la granja.",
    perimeterPointLabelState: "Etiqueta de punto.",
    farmLongitudeState: "Longitud de la granja.",
    farmLatitudeState: "Latitud de la granja.",
    farmNameH: "Nombre de la finca",
    farmTypeH: "El tipo de finca donde se realizan las diferentes actividades.",
    farmOwnerH:
      "Nombre del propietario de una granja (generar automáticamente el nombre del granjero ingresando información)",
    ownershipTypeH:
      "El tipo de agricultores que poseen/controlan la tierra que cultivan y los que no.",
    govtRegNumbH:
      "Número de registro de la finca que fue asignado por el regulador",
    contractMatingH:
      "Código del programa de apareamiento por contrato en el que participa la granja",
    productionSystemH:
      "Cuál es el sistema de producción que se utiliza en la finca",
    cooperativeIDH:
      "Identificación de una cooperativa de la cual la finca es miembro",
    licenseNumberH:
      "Número de identificación en una licencia emitida por el regulador que la identifica con el propietario.",
    licenseExpiryDateH: "Fecha de vencimiento de la licencia actual",
    regularNameH: "Nombre del regulador que emitió la licencia",
    regularRepName:
      "Nombre de la persona que representa al regulador que liberó la licencia",
    countryH: "País donde se encuentra la finca.",
    stateH: "Región del país donde se ubica la finca.",
    cityH: "Ciudad donde se ubica la finca.",
    streetH: "Nombre de la calle de la finca.",
    houseNumberH: "Número de casa de la finca.",
    totalFarmSizeH:
      "El tamaño de la finca es la suma de la tierra que actualmente cultiva la finca, incluida la tierra en barbecho pero excluyendo la tierra con vegetación natural, árboles o pastos.",
    farmLatitudeH:
      "Es la medida de la distancia al norte o al sur del ecuador. Se mide con 180 líneas imaginarias que forman círculos alrededor de la Tierra de este a oeste, paralelos al Ecuador.",
    farmLongitudeH:
      "Mide la distancia al este o al oeste del primer meridiano.",
    perimeterLengthH:
      "Longitud del perímetro de las fincas (longitud de la cerca)",
    perimeterPointLabelH:
      "Etiqueta de punto. Usando tres parámetros (latitud, longitud y etiqueta) describimos el perímetro de la finca y cualquier segmento dentro de la finca.",
    perimeterPointLatH: "Latitud de un punto en la finca",
    perimeterPointLongH: "Longitud de un punto en la finca",

    noProductAvailable: "Ningún producto disponible ",
    farmUpdated: "Granja actualizada",
    performance: "Actuación",
    milkInformation: "Información sobre la leche",
    farmNameRequired: "Se requiere el nombre de la granja",
  },
  login: {
    welcome: "¡Bienvenido! Inicie la sesión",
    welInfo: "Ingrese sus credenciales",
    login: "Iniciar sesión",
    forgotPassword:"Has olvidado tu contraseña",
    forgotPasswordDesc:"Ingrese la dirección de correo electrónico asociada con su cuenta. Los detalles de la contraseña se enviarán a su dirección de correo electrónico.",
    backToLogin:"Atrás para iniciar sesión",
  },
  actionListmod: {
    actionList: "Lista de acciones",
    tODAY: "Today",
    createTask: "Crear tarea",
    myActivities: "Mis Actividades",
    jhonSmith: "Jhon Smith",
    farmID: "ID de la granja",
    dateOfEvent: "Fecha del evento",
    actionRequired: "Se requiere la acción",
    actionTaken: "Medida adoptada",
    animalEventID: "ID del evento del animal",
    cANCEL: "Cancelar",
    cONFIRM: "Confirmar",
    sTATEMENT: "¿Seguro que desea eliminar este registro?",
    dAY: "Día",
    wEEK: "Semana",
    mONTH: "Mes",
    sUBMIT: "Enviar",
    startDate: "Fecha de inicio",
    endDate: "Fecha de finalización",
    rEPEAT: "Repetir",
    taskCategory: "Categoría de la tarea",
    pRIORITY: "Prioridad",
    aSSIGNEE: "Cesionario",
    selectLocation: "Seleccionar ubicación",
    selectAnimals: "Seleccionar uno o más animales",
    dESCRIPTION: "Descripción",
    customRecurrence: "Custom Recurrence",
    repeatEvery: "Repeat Every",
    taskName: "Nombre de la tarea",
    enterDescription: "Ingresar descripción",
    toDo: "Hacer",
    assignTo: "Asignar a",
    status: "Estado",
    nOTE: "Nota",
    noTaskAvailable: "Ninguna tarea disponible",
    healthRecord: "Registros de salud",
    iD: "ID",
    tAG: "Etiqueta",
    dateOfbirth: "Fecha de nacimiento",
    taskTakenat: "Tarea asumida en",
    gENDER: "Género",
    bREED: "Raza",
    regDate: "Fecha reg.",
    updateHealthRecord: "Actualizar Registro Sanitario de Animales",
    treatment: "Tratamiento",
    reasonOftreatment: "Razón del tratamiento",
    treatmentDate: "Fecha de tratamiento",
    dIAGNOSIS: "Diagnóstico",
    drugId: "ID del medicamento",
    drugName: "Nombre del medicamento",
    drugWithdrawalperiod: "Periodo de retirada del fármaco",
    attendingVeterinarian: "Veterinario a cargo",
    packId: "ID del paquete",
    noItemsselected: "No se ha seleccionado ningún ítem",
    healthRecordsubmission: "Envío de la historia clínica",
    inseminationRecordsubmission: "Envío de registro-inseminación",
    inseminatorName: "Nombre del inseminador",
    inseminatorId: "ID del inseminador",
    conceptionRate: "Tasa de concepción",
    dateOfmeasurement: "Fecha de medición",
    recordSubmission: "Envío de registro",
    uPDATE: "Actualizar",
    updateTask: "Actualizar tarea",
  },
  inseminatorStatisticsInfo: {
    addInseminatorInfo: "Añadir información sobre inseminador",
    inseminatorNumber: "Número del inseminador",
    loadingInseminatorPleaseWait: "Cargando inseminador... Espere.",
    searchByIDAndName: "Búsqueda por ID y nombre",

    inseminatorInfoAdded: "Se ha añadido la información del inseminador",
    inseminatorInfoNotAdded: "No se ha añadido la información del inseminador",

    inseminatorInfoUpdated: "Se ha actualizado la información del inseminador",
    inseminatorInfoNotUpdated:
      "No se ha actualizado la información del inseminador",
    editAInseminatorInfo: "Editar información del inseminador",
    inseminatorList: "Lista de inseminador",
    inseminatorInfoDetails: "Detalles de la información del inseminador",
    updateInseminatorInfo: "Update Inseminator Info",
  },
  organizationNtrInfo: {
    loadingOrdersPleaseWait: "Cargando pedidos... Espere",
    addStocks: "Añadir existencias",
    addStock: "Añadir existencias",
    quantity: "Cantidad",
    selectUnit: "Seleccionar unidad",
    farmProducts: "Productos de la granja",
    cost: "Costo",
    transactionID: "ID de transacción",
    recipientID: "ID del receptor",
    orderID: "ID del pedido",
    recepientName: "Nombre del receptor",

    createAOrder: "Crear un pedido",
    totalStocks: "Existencias totales",
    orders: "Pedidos",
    totalPending: "Pendiente total",
    totalDelivered: "Total entregado",
    searchByRecepientNameOrderIdRecepientId:
      "Search By Recepient Name, Order Id, Recepient Id",

    chooseTheDate: "Elige la fecha",
    transactionDate: "Fecha de transacción",
    selectCategory: "Seleccionar categoría",
    volumeOfProduct: "Volumen de producto",
    productQuantity: "Cantidad de producto",
    productRecipientId: "ID del receptor de producto",
    productRecipientName: "Nombre del receptor de producto",
    productRecipientType: "Tipo de receptor de producto",
    singleProduct: "Producto único",
    orderPlaced: "Pedido realizado",
    orderNotPlaced: "Pedido no realizado",
    totalPrice: "Precio total",
    currency: "Moneda",
    selectCurrency: "Seleccionar moneda",
    address: "Dirección",
    enterAddress: "Ingresar dirección",
    attachments: "Archivos adjuntos",
    chooseFile: "Elija el archivo",

    nameOfTheFarm: "Nombre de la granja",
    loremIpsumHasBeenTheIndustrySStandardDummyText:
      "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a",
    billedTo: "Facturado a",
    orderStatus: "Estado del pedido",
    selectStatus: "Seleccionar estado",
    cadbury: "Cadbury",
    totalAmount: "Cantidad total",
    deliveryCharges: "Los gastos de envío",
    orderDetails: "Detalles del pedido",

    deliveryOnTime: "Entrega a tiempo",

    productID: "ID del Producto",

    productRegistration: "Registración del producto",
    enterTheNameOfTheProduct: "Introduce el nombre del producto",
    nameOfTheProduct: "Nombre del producto",
    productAdded: "Producto agregado",
    productNotAdded: "Producto no agregado",
  },
  drug: {
    dRUGS: "Medicamentos",
    registerAdrug: "Registrar un medicamento",
    sEARCH: "Búsqueda",
    genericName: "Nombre genérico",
    manufacturer: "Fabricante",
    distributor: "Distribuidor",
    registrationDate: "Fecha de registro",
    drugRegistration: "Registro de Medicamentos",
    drugInformation: "Información sobre medicamentos",
    drugId: "ID del medicamento",
    drugName: "Nombre del medicamento",
    drugGenericname: "Nombre genérico del medicamento",
    drugManufacturer: "Fabricante de medicamentos",
    distributorName: "Nombre del distribuidor",
    drugRegistrationdate: "Fecha de registro del medicamento",
    nextDrug: "Próximo medicamento",
    editDrug: "Editar medicamento",
    updateDrug: "Actualizar medicamento",
    deleteDrug: "Borrar medicamento",
    noRecordfound: "Ningún registro encontrado",
    addDrug: "Añadir medicamento",
    statementDrug:
      "Se ha borrado el medicamento. Haga clic en el botón a continuación para registrarlo ",
    cANCEL: "Cancelar",
    cONFIRM: "Confirmar",
    sTATEMENT: "¿Seguro que desea eliminar este registro?",
    ok: "Vale",
    information: "Información",
    packExpiration: "Fecha de caducidad",
    packOrder: "Pedido de paquetes",
    packPrescription: "Prescripción del paquete",
    packReservation: "Reserva del paquete",
    packLocation: "Ubicación del paquete",
    drugDozedam: "Dosis diaria del medicamento para el padre",
    drugDozecalf: "Dosis diaria del medicamento para el becerro",
    drugFormate: "Forma del medicamento",
    drugDistributor: "Distribuidor de medicamentos",
    drugActiveingridents: "Principio activo del medicamento",
    drugSubstitutionId: "ID de sustitución del medicamento",
    packId: "ID del paquete",
    packBatchNumber: "Número de lote del paquete",
    drugIdStatement: "Número de lote del medicamento",
    drugNameSatement: "Nombre comercial bajo lo cual se vende el medicamento. ",
    drugGenericnameStatement:
      "Composición química del medicamento en vez del nombre comercial bajo lo cual se vende el medicamento.",
    drugFormateSatement: "Número de lote del medicamento.",
    drugDozecalfSatement:
      "Saber la cantidad de la dosis diaria para el becerro",
    drugDozedamStatement:
      "Saber la cantidad de la dosis diaria para el becerro.",
    drugManufacturerStatement: "Detalles del fabricante de medicamentos",
    drugDistributorStatement: "Detalles del distribuidor de medicamentos.",
    drugRegistrationdateStatement:
      "Fecha de registro del medicamento en un país específico",
    drugActiveingridentsStatement: "Lista de principios activos.",
    drugSubstitutionIdStatement:
      "ID de la posible sustitución del medicamento si el medicamento principal no esté disponible.",
    packIdStatement: "Código de barras o RFID del paquete.",
    packBatchNumberStatement:
      "Número de lote asignado al paquete por el fabricante.",
    locationWarehouseID: "ID del almacén de ubicación",
    locationWarehouseIDState: "ID del almacén dónde está el paquete",
    locationRackID: "ID de la estante de ubicación",
    locationRackIDStatement: "ID de la estante dónde se almacena el paquete",
    locationTierID: "ID de la hilera de ubicación",
    locationTierIDStatement:
      "ID de la hilera en la estante dónde se almacena el paquete",
    locationPositionID: "ID de la posición de la ubicación",
    locationPositionIDStatement:
      "ID de la posición en la hilera dónde se almacena el paquete.",
    storageTemperatureCondition:
      "Condición de la temperatura de almacenamiento",
    storageTemperatureConditionStats:
      "Condición del almacenamiento del paquete.",
    containerForm: "Forma del contenedor",
    containerFormStatement:
      "Forma del contenedor dónde se embaló el medicamento.",
    consistQuantity: "Consisten en cantidad",
    consistQuantityStatement:
      "Cantidad de pastillas, botellas, etc. en el paquete",
    releaseId: "ID de liberación",
    releaseIdStatement:
      "ID asignado después que el granjero ha tomado el paquete",
    releaseDate: "Fecha de liberación",
    releaseDateStatement:
      "Fecha en que el granjero ha tomado el paquete de la existencia.",
    packManufacturedDate: "Fecha de fabricación del paquete",
    packManufacturedDateStatement: "Fecha de fabricación del paquete",
    packImportedDate: "Fecha de importación del paquete",
    packImportedDateStatement: "Fecha de importación del paquete",
    packExpirationDate: "Fecha de caducidad del paquete",
    packExpirationDateStatement: "Fecha de caducidad del paquete",
    expiredSoonFlag: "Expired Soon Flag",
    expiredSoonFlagState: "Aviso sobre el paquete que caducará pronto.",
    packTotalVolumeLeft: "Volumen total de sobra del paquete",
    packTotalVolumeLeftState:
      "Número total de paquetes con los mismos ingredientes en existencia.",
    packOrderID: "ID del pedido de paquetes",
    packOrderIDState:
      "ID que se asignó después de pedir el paquete del distribuidor",
    packQuantityOrdered: "Cantidad pedida de paquetes",
    packQuantityOrderedState:
      "Número de paquetes que se ordenó al distribuidor.",
    packPrice: "Precio del paquete",
    packPriceStatement: "Precio del paquete.",
    priceCurrency: "Precio Moneda",
    packPricecurrency: "Moneda del precio del paquete",
    packPricecurrencyState:
      "Nombre de la moneda en la que se propone el precio.",
    packPaydate: "Fecha de pago del paquete",
    payDate: "Fecha de pago",
    packPaydateState: "Fecha en que se realizó el pago al distribuidor.",
    packShippingID: "ID de envío del paquete",
    shippingID: "ID de envío",
    packShippingIdState: "ID de envío del paquete al llegar del distribuidor.",
    packShippingDate: "Fecha de envío del paquete",
    shippingDate: "Fecha de envío",
    packShippingDateState: "Fecha de llegada del paquete en stock.",
    packOrderStatus: "Estado del pedido del paquete",
    packOrderStatusState: "Situación del pedido actual.",
    recepientKeeperId: "ID del cuidador del receptor",
    recepientKeeperIdStatement:
      "Nombre del individuo/ organización que ha recibido el paquete",
    recepientFarmId: "ID de la granja receptora",
    recepientFarmIdStatement:
      "ID de la granja dónde el animal receptor del medicamento pertenece",
    recepientAnimalId: "ID del animal receptor",
    recepientAnimalIdState:
      "ID del animal al que se le prescribió el medicamento",
    specialistComments: "Comentarios del especialista",
    specialistCommentsState:
      "Comentarios del especialista/ veterinario sobre la prescripción.",
    specialistName: "Nombre del especialista",
    specialistNameState:
      "Nombre del especialista/ veterinario que ha prescrito el medicamento.",
    specialistID: "ID del especialista",
    specialistIDState:
      "ID del especialista/ veterinario que ha prescrito el medicamento.",
    reservedByKeeperId: "ID de reservado por el cuidador",
    reservedByKeeperIdState: "ID del cuidador que ha reservado el paquete.",
    reservedByFarmId: "ID de reservado por la granja",
    reservedByFarmIdState: "ID de la granja que ha reservado el paquete.",
    reservationTimeoutDate: "Fecha de tiempo de espera de la reserva",
    reservationTimeoutDateState:
      "Fecha en que la reserva se cancelará automáticamente si el paquete no es comprado.",
    reservationTimeout: "Tiempo de espera de la reserva",
    reservationTimeoutState:
      "Número de horas después de las cuales la reserva se cancelará automáticamente si el paquete no es comprado o recogido",
    reservationDate: "Fecha de reserva",
    reservationDateState: "Fecha de reserva del paquete.",
    reservationStatus: "Estado de la reserva",
    reservationStatusState:
      "Estado de la reserva del paquete. El paquete no está disponible para otros si reservado.",
    loadingDrugsPleaseWait: "Cargando medicamentos... Por favor espere",
    quantityOrder: "Orden de cantidad",
    keeperID: "Identificación del guardián",
    timeoutDate: "Fecha de tiempo de espera",
    warehouseID: "Identificación del almacén",
    rackID: "ID de bastidor",
    tierID: "ID de nivel",
    positionID: "Identificación de la posición",
    temperatureCondition: "Condición de temperatura",
    manufactureDate: "Fecha de fabricacion",
    importedDate: "Fecha importada",
    totalVolumeLeft: "Volumen total restante",
  },
  reports: {
    myReports: "Mis informes",
    satelliteReports: "Informes satelitales",
    weatherReports: "Informes meteorológicos",
    pregnancyAnalytics: "Análisis de embarazo",

    semenEmbroyAnalytics: "Análisis de semen/embrión",
    semenAnalytics: "Análisis de semen",
    embryoAnalytics: "Análisis de embriones",
    calfAnalytics: "Análisis de terneros",
    milkProduction: "Producción de leche",
    totalMilkType: "Tipo de leche total",
    totalAnimalAnalytics: "Análisis total de animales",
    animalAnalytics: "Análisis de animales",
    analyticsAndReporting: "Análisis e informes",
    filterByCountry: "Filtrar por país",
    filterByFarm: "Filtrar por finca",
    filterByRegion: "Filtrar por región",
    filterByMonth: "Fitrar por mes",
    filterByDate: "Filtrar por fecha",
    filterByRole: "Filtrar por función",
    filterByYear: "Filtrar por año",
    filterByTrait: "Filtrar por atributo",
    avgBreedingValue: "Valor genético medio",
    avgEconomicIndex: "Índice económico medio",
    breederReport: "Informe del reproductor",
    semenTransferDate: "Fecha de transferencia de semen",
    semenEmbryoProductionReport:
      "Informe de producción de semen/ embrión (semen)",
    semenProducts: "Productos de semen",
    meatProducts: "Productos cárnicos",
    totalProducts: "Productos totales",
    semenEmbryoReport: "Informe de semen/embrión",
    numOfStraws: "Número de pajitas",
    collectionDate: "Fecha de colección",
    productionReport: "Reporte de produccion",
    receipientId: "Identificación del destinatario",
    embryoId: "ID del embrión",
    semenStrawId: "ID de la pajita de semen",
    dataScientist: "Científico de datos",
    dataScientistReport: "Informe científico de datos",
    productReport: "Informe de producto",
    dairyProducts: "Productos lácteos",
  },
  genoPerformance: {
    performanceOfGenoType: "Desempeño del genotipo",
    addAGenoType: "Añadir un genotipo",
    breedName: "Breed Name",
    chromosome: "Cromosoma",
    sequenceChange: "Cambiar secuencia",
    inheritance: "Herencia",
    diseaseName: "Nombre de la enfermedad",
    referenceSequence: "Secuencia de la referencia",
    pubmedReference: "Referencia Pubmed",
    genoTypeRegistration: "Registro de genotipos",
    breed: "Raza",
    editAGenoType: "Editar un genotipo",
    editGenoType: "Editar genotipo",
    loadingGene: "Cargando Geno... Por favor espera",
    geneTypeList: "Lista de genotipos",
  },
  reportings: {
    conception: "Concepción (Científica de datos)",
    performanceOfGenoData: "Rendimiento del genotipo (Científica de datos)",
    totalInsemination: "Inseminación Total",
    embryo: "Embrión",
    animalVaccinationRecord: "Registro de vacunación de animales",
    dataNotAvailable: "Los datos no están disponibles para esta granja.",
    pregnancyStatus: "Estado de embarazo",
    healthReport: "Reporte de salud",
    heavyMilk: "leche pesada",
    standardMilk: "Leche estándar",
  },
  sidebar: {
    healthAnalytics: "Análisis de salud",
    productionAnalytics: "Análisis de producción",
  },
  epd: {
    regNo:
      "Animal Reg No es el código único que se le da al animal mediante un medio de marcado, lo que garantiza un proceso realizado para identificar y rastrear animales específicos.",
    internationalID: "Identificación Internacional de Animal",
    location: "País / Región de nacimiento del animal",
    animalName: "Nombre Estándar / Nomenclatura del Animal",
    gender: "Sexo del animal (macho/hembra)",
    additionalIDMethod:
      "Qué método se utilizó para identificar al animal (p. ej., crotal, tatuaje)",
    damID:
      "DNI o Número de registro de la madre del animal-la progenitora de un animal/DNI de Número de la madre biológica",
    sireId:
      "Una identificación o número de registro del progenitor masculino de un animal, especialmente un toro mantenido para reproducción o semen de toros utilizado para inseminación artificial.",
    dateOfBirth: "Fecha de nacimiento del animal.",

    breederHerdCode:
      "Código de rebaño de criadores proporcionado principalmente por asociaciones de criadores",
    seasonofBirth: "Temporada de nacimiento del animal anotado en mes sabio",
    birthYear: "El año en que nació el animal.",
    birthManagementCode:
      "Código de gestión de la natalidad proporcionado principalmente por el usuario/agricultor",
    birthSex: "Género del animal (macho/hembra)",
    birthWeight: "Peso al nacer del ternero",
    primaryBreed: "Mayor % Aporte genético del animal",
    secondaryBreed: "Menor % Aporte genético del animal",
    breedComposition: "El porcentaje de composición de raza se refiere a la representación proporcional de diferentes razas dentro de la estructura genética de un animal individual o un grupo de animales. ",
    conceptionMethod:
      "Cómo fue concebido el animal (apareamiento natural/inseminación/transferencia embrionaria).",
    accuracyWeight: "Precisión Peso",
    damAge: "La edad de la presa en meses/años, p. 2 años, 24 meses",
    weaningWeight: "Destete Peso de un animal en el momento del destete.",
    weaningDate: "La fecha en que el animal fue destetado.",
    weaningSex:
      "El sexo del animal que fue destetado. La suma de las características que distinguen a los organismos sobre la base de su función reproductiva.",
    managementPastureCode:
      "Código dado a la gestión / pastura por usuario / agricultor.",
    creep:
      "La alimentación progresiva es la práctica de proporcionar alimento suplementario (grano o forraje) a los terneros lactantes.",
    weaningContemporaryGroupCode: "Código de Destete Peso Grupo Contemporáneo",
    birthContemporaryCode: "Nacimiento Código Contemporáneo",

    yearlingDate: "Fecha del animal de un año o en el segundo año de su edad",
    managementFeedUnitCode:
      "Código dado a la unidad de gestión/alimentación por el usuario",
    yearlingSex: "El sexo del animal en el momento del añal.",
    yearlingWeight:
      "El peso al año es una medida del crecimiento directo posterior al destete y se usa a menudo para reflejar el rendimiento potencial de la progenie destinada al mercado en el corral de engorde, medido en libras de ternero.",
    yearlingHeight: "Altura del animal en el momento del nacimiento",
    yearlingWeightContemporaryGroupCode:
      "Código de Peso al Año Grupo Contemporáneo",

    weaningYearlingWeightContemporaryGroupCode:
      "Código de Peso al Destete o al Año Grupo Contemporáneo",
    daysOnFeed:
      "Número de días alimentados con ese alimento en particular Ej.: el ganado joven en crecimiento se alimenta con una dieta de alta energía para producir carne de res comercializable a un bajo costo de ganancia. Dependiendo del peso corporal inicial y la edad del ganado, el período de alimentación varía de 60 días a 12 meses.",
    managementFeedUnitPenCode:
      "Código proporcionado a la unidad de gestión/alimentación/bolígrafo por el usuario",
    harvestDate: "Fecha del animal sacrificado (matado) para carne",
    gradingDate:
      "La fecha de las canales se clasificó de acuerdo con un criterio particular",
    carcassSex: "Sexo de la canal",
    dateonFeed:
      "Fecha en que el animal fue cambiado a un nuevo alimento Ej.: ganado joven en crecimiento = (los animales son alimentados con una dieta de alta energía para producir carne de res comercializable a un bajo costo de ganancia. Dependiendo del peso corporal inicial y la edad del ganado, el período de la alimentación varía de 60 días a 12 meses",
    KPH: "% KPH es el porcentaje de grasa total que se encuentra en la cavidad corporal de una canal específicamente en las regiones de los riñones, la pelvis y el corazón. A menudo, un calificador del USDA lo estima visualmente o se puede calcular en función del cambio en el peso de la canal después de la eliminación de la grasa de estas áreas de la canal. La mayoría de las canales tienen de 1 a 4 por ciento KPH. Es el último factor utilizado para determinar el grado de rendimiento.",
    carcassWeight:
      "El peso de la canal es el peso caliente o no refrigerado después de la cosecha y el retiro de la piel, la cabeza, el tracto gastrointestinal y los órganos internos. A veces se informa como peso de la canal caliente (HCW). El peso de la canal es un factor importante para determinar el valor de la canal cuando el ganado se vende en base al peso deshuesado o en una cuadrícula basada en el valor.",
    fatThickness:
      "El grosor de la grasa se mide en pulgadas con una regla pequeña. El lugar adecuado para medir el grosor de la grasa dorsal es ¾ de la longitud del chuletón desde el extremo de la columna vertebral, perpendicular a la superficie exterior de la canal.",
    marbling:
      "El marmoleado es la grasa intramuscular no saturada (saludable) visible que se acumula dentro del músculo y entre los haces de fibras musculares.",
    ribeyeArea:
      "Cantidad de área de ojo de bife (lomo o músculo longissimus dorsi) medido entre las costillas 12 y 13 en pulgadas cuadradas usando una cuadrícula (por ejemplo, 8, 9 o 10 pulgadas). El área del chuletón está directamente relacionada con la cantidad de músculo en la canal.",
    animalStatus: "Estado del animal en la granja, por ejemplo: en la granja, vendido, muerto, etc."
  },
  manageAnimalGroupings: {
    resetModeTooltip: `
    MODO DE RESTABLECIMIENTO <br>
    En este modo <br>
    1) Establecer/definir todas las características de los grupos contemporáneos (CG) para todos los rasgos de interés. <br>
    2) Asignar todos los animales a un CG correspondiente. <br>
    3) Si la asignación de animales no es satisfactoria, ajuste/cambie los CG y luego vuelva a asignar los animales a los nuevos CG correspondientes. <br>
    4) Repita los pasos anteriores, si es necesario, hasta que esté satisfecho con los CG y la agrupación/asignación de animales correspondiente.<br>
        `,
    maintainanceModeHeadingTooltip: `Una vez que finalice el (modo) RESET, ingresará al MODO DE MANTENIMIENTO donde los EDP calculados en el RESET se mantendrán constantes para cada animal hasta el próximo RESET (que podría ser dentro de 2 a 6 meses). Además, cualquier nuevo animal agregado o nacido de animales que ya estén en el sistema durante el MODO DE MANTENIMIENTO tendrá sus DEP calculadas a través de otro método, un método de ancestros, hasta que se vuelvan a calcular en el próximo REINICIO.`,
    maintainanceModeTooltip: `Después de completar el MODO DE REINICIO, presione el botón REINICIO FINALIZADO para permitir que el sistema calcule las DEP de todos los animales, finalice el MODO DE REINICIO e inicie el MODO DE MANTENIMIENTO.`,
    resetToggleTooltip: `Habilite Reset Toggle en la configuración del modelo EPD para asignar animales a los CG.`,
  },
  geneticsAndBreeding: {
    geneticsAndBreeding: "Genética y reproducción",
    geneticSearchTool: "Herramienta de búsqueda genética",
    dataSubmission: "Envío de datos",
    animalsWithExpectedProgenyDifferences:
      "Animales con diferencias de progenie esperadas (EPD)",
    searchByAnimalIdName: "Búsqueda por ID de animal, nombre",
    rowsPerPage: "Filas por página",
    individualEntry: "Entrada Individual",
    bulkEntry: "Entrada masiva",
    registerANewAnimalOrSelectAnExistingAnimal:
      "Registre un nuevo animal o seleccione un animal existente.",
    registerNewAnimal: "Registrar Nuevo Animal",
    selectExistingAnimal: "Seleccionar animal existente",
    animalID: "Identificación de animales",
    animalName: "Nombre de animal",
    tag: "Etiqueta #",
    dateOfBirth: "Fecha de nacimiento",
    gender: "Género",
    birthDate: "Fecha de nacimiento",
    birthWeightLb: "Peso al nacer (lb)",
    birthWeightKg: "Peso al nacer (kg)",
    weaningWeightLb: "Peso al destete (lb)",
    weaningWeightKg: "Peso al destete (kg)",
    yearlingWeightLb: "Peso al año (lb)",
    yearlingWeightKg: "Peso al año (kg)",
    carcassWeightLb: "Peso de la canal (lb)",
    carcassWeightKg: "Peso de la canal (kg)",
    animalSelection: "Selección de animales",
    animalSearchTool: "Herramienta de búsqueda de animales",
    back: "atrás",
    searchByEPDs: "Buscar por EPDS",
    searchByIds: "Buscar por IDS",
    selectBreed: "Raza seleccionada",
    selectGender: "Seleccione género",
    selectRequiredBreedForCattle: "Seleccione la raza requerida para el ganado",
    resetFilter: "Restablecer filtro",
    birthWeightHeader: "Peso al nacer(BW): ",
    birthWeightDef:
      "Compara las diferencias en el peso de los terneros al nacer y se mide en libras o kg.",
    weaningWeightHeader: "Peso al destete(WW): ",
    weaningWeightDef:
      "WW EPD es una estimación del crecimiento previo al destete que se mide en libras o kg.",
    yearlingWeightHeader: "Peso al año(YW): ",
    yearlingWeightDef:
      "YW EPD es una estimación del crecimiento posterior al destete que se mide en libras o kg.",
    ribEyeAreaHeader: "Zona de chuletón(REA): ",
    ribEyeAreaDef:
      "REA mide el tamaño del músculo que nos da el chuletón en pulgadas cuadradas. Las EPD de las EPD reflejan las diferencias en una medición ajustada del área de costillas de 365 días basada en las mediciones de la carcasa de ganado cosechado.",
    marblingHeader: "Marmling(MARB): ",
    marblingDef:
      "El MARB EPD se encuentra en unidades de porcentaje de grasa intramuscular dentro del chuletón. El EPD de marco refleja las diferencias en un puntaje de marmolling ajustado de 365 días (grasa intramuscular, [FMI]) basada en las mediciones de la carcasa del ganado cosechado.",
    fatThicknessHeader: "Espesor de grasa(FAT): ",
    fatThicknessDef:
      "Pulgadas de grasa posterior (en centésimas de pulgada) es la unidad de medición para Ft.",
    carcassWeightHeader: "Peso de la carcasa (CW): ",
    carcassWeightDef:
      "El peso de la carcasa es un rasgo beneficioso cuando se considera el impacto que las libras tienen en relación con el valor final del producto. Con el mismo punto final constante de edad, los toros con valores más altos para el peso de la carcasa agregarán más libras de peso de carcasa caliente en comparación con los toros con valores más bajos para el peso de la carcasa.",
    yieldGradeHeader: "Grado de rendimiento (YG): ",
    yieldGradeDef:
      "El sistema de puntuación del grado de rendimiento del USDA es la unidad de medida del YG EPD. El grado de rendimiento 1 son canales más magras y más minoristas.",
    milkHeader: "Leche (MK): ",
    milkDef:
      "El MK EPD se mide en libras de peso de destete de ternero debido a la capacidad de ordeño de su madre.",
    totalMaternalHeader: "Total Materna(TM): ",
    totalMaternalDef:
      "TM mide el impacto en el peso del destete de la pantorrilla debido a la producción de leche y la genética de la vaca para el crecimiento.",
    calvingEaseDirectHeader: "ELECHE DE CALVING DIRECT(CED): ",
    calvingEaseDirectDef:
      "El CED EPD figura como un porcentaje de calvings sin asistencia.",
    calvingEaseMaternalHeader: "ELECCIÓN DE CARRINGA MATERNAL (CEM): ",
    calvingEaseMaternalDef:
      "Mide la capacidad de las hijas de un toro para las pantorrillas sin asistencia como niños de dos años.",
    stayabilityHeader: "Estabilidad(STAY): ",
    stayabilityDef:
      'El ST EPD predice la capacidad de un toro para el padre de vacas que "se quedan". El ST EPD se muestra como un porcentaje de cuánto más probable es que las hijas de un toro permanezcan en su rebaño hasta los 6 años.',
    docilityHeader: "Docilidad(DOC): ",
    docilityDef: "DOC mide el temperamento del ganado.",
    max: "MAX",
    min: "MIN",
    accuracy: "EXACTITUD",
    sortBy: "Ordenar por",
    traits:
      "Los rasgos que se muestran en Gray están en desarrollo, que vienen en el segundo trimestre, 2023.",
    searchResults: "Resultados de la búsqueda",
    recordsFound: "registros encontrados",
    compareSelected: "COMPARAR SELECCIONADO",
    animalIdentification: "Identificación de animales",
    errorMessage: {
      birthWeight:
        "El valor máximo del peso al nacer no puede ser menor que el peso al nacer mínimo",
      weaningWeight:
        "El valor máximo de peso de destete no puede ser menor que el peso de destete mínimo",
      yearlingWeight:
        "El valor máximo de peso de un año no puede ser menor que el mínimo de peso de un año",
      carcassWeight:
        "Peso de la carcasa El valor máximo no puede ser menor que el peso al nacer mínimo",
      fatThickness:
        "El valor máximo del espesor de grasa no puede ser menor que el peso mínimo de destete mínimo",
      marbling:
        "El valor máximo de marmling no puede ser menor que el peso de un año mínimo",
      ribeyeArea:
        "El valor máximo del área de Cutyee no puede ser menor que el peso al nacer mínimo",
      yieldGrade:
        "El valor máximo de grado de rendimiento no puede ser menor que el peso de destete mínimo",
      milk:
        "El valor máximo de leche no puede ser inferior al peso mínimo al destete",
    },
    reg: "Registro #",
    name: "Nombre",
    sex: "Sexo",
    tattoo: "Tatuaje",
    dob: "fecha de nacimiento",
    EPD: "EPD",
    rank: "Rango",
    searchValue: "Valor de búsqueda",
    typeHere: "Escriba aquí",
    searching: "Buscando...",
    fetchingResult: "Resultados para obtener ... por favor espera",
    animalsMatchedYourCriteria: "Los animales coincidían con sus criterios",
    manageAnimalsGrouping: "Gestionar la agrupación de animales",
    manageAnimalGroupings: "Manejar la agrupación de animales",
    assignAnimalToContemporaryGroups: "Asignar animal a grupos contemporáneos",
    resetMode: "Modo de reinicio",
    enterResetMode: "Ingrese al modo de reinicio",
    maintainanceMode: "Modo de mantenimiento",
    assigningAnimals: "Asignación de animales",
    excludedAnimals: "Animales excluidos",
    ungroupedAnimals: "Animales no agrupados",
    assignAnimalsToCGS: "Asignar animal a CGS",
    reset: "Reiniciar",
    excludeAnimals: "Excluir animales",
    resetToMaintainanceMode:
      "Restablecimiento finalizado: cambio al modo de mantenimiento",
    contemporaryGroupsSettings: "Configuración de grupos contemporáneos (CG)",
    selectTrait: "Seleccionar rasgo",
    selectTraitDescription:"Seleccionar rasgo se refiere al proceso de elegir un rasgo específico",
    traitsType: {
      birthWeight: "Peso de nacimiento",
      weaningWeight: "Peso de destete",
      yearlingWeight: "Peso de un año",
      carcassWeight: "Peso de la carcasa",
    },
    addNewGroup: "Agregar nuevo grupo",
    contemporaryGroup: "Grupo Contemporáneo",
    contemporaryGroups: "Grupos contemporáneos",
    editGroup: "Editar grupo",
    birthCGCode: "Código de nacimiento (CG)",
    groupName: "Nombre del grupo",
    birthSex: "Sexo de nacimiento",
    conceptionMethod: "Método de concepción",
    weaningCGCode: "Código de destete (CG)",
    yearlingCGCode: "Código de un año (CG)",
    dateWeight: "Peso de la fecha",
    weaningyearlingCGcode: "Código de destete/año (CG)",
    carcassCGCode: "Código de Carcass (CG)",
    breedOfDom: "Raza de dom",
    addNewContemporaryGroup: "Agregar nuevo grupo contemporáneo",
    createNewGroup: "Crea un nuevo grupo",
    selectFromDifferentTraits: "Seleccione de diferentes rasgos",
    contemporaryGroupName: "Nombre del grupo contemporáneo",
    enterNameHere: "Introduzca nombre aquí",
    groupNameIsRequired: "Se requiere el nombre del grupo",
    birthYearRange: "Rango de año de nacimiento",
    theYearAnimalWasBorn: "El año en que nació el animal",
    birthYearIsRequired: "Se requiere año de nacimiento",
    genderOfNewBornAnimal: "Género del animal recién nacido",
    selectSex: "Seleccionar sexo",
    theweightOfAnimalAtBirth: "El peso del animal al nacer",
    maximumKg: "Máximo (kg)",
    minimumKg: "Minimo(kg)",
    aSeasonisAPeriodOfYear:
      "Una temporada es un período del año que se distingue por condiciones climáticas especiales.",
    seasonofBirthIsRequired: "Se requiere temporada de nacimiento",
    majorGenericContributionOfAnimal:
      "Mayor % de contribución genética de animales",
    primaryBreedCompostionIsRequired:
      "Se requiere composición de la raza primaria",
    secondaryBreedCompostionIsRequired:
      "Se requiere una composición de raza secundaria",
    howTheAnimalWasConceived:
      "Cómo se concibió el animal (apareamiento natural/inseminación/transferencia de embriones)",
    conceptionMethodIsRequired: "Se requiere un método de concepción",
    epdModelSettings: "Configuración del modelo EPD",
    forResetMode: "Para el modo de reinicio",
    progenyWeightingFactor: "Factor de ponderación de progenie",
    weightGivenToTheProgenyFactor:
      "Peso dado al factor de progenie en relación con el factor CG para el cálculo de EPD en el modo de reinicio. Si solo se debe tener en cuenta el factor CG, el valor de este parámetro es 0.",
    enterNumber: "Ingresar número",
    enterBreed: "Introducir raza",
    valueShouldBeBetween0and1: "El valor debe estar entre 0 y 1",
    resetDuration: "Reiniciar duración",
    timeIntervalBetweenLastAndFirstResetMode:
      "Intervalo de tiempo entre el último y el nuevo modo de reinicio, al final del cual se habilita el nuevo modo de reinicio y se calculan los nuevos CG y EPD.",
    enterNumberOfDays: "Ingrese el número de días",
    valueCannotBeNegative: "¡El valor no puede ser negativo!",
    criticalProgenyPopulation: "Población de progenie crítica",
    minimumNumberOfProgenyRecords:
      "Número mínimo de registros de descendencia del animal individual en el sistema necesarios para lograr una precisión de progenie (APD1) superior al 50 % (para precisión de pedigrí)",
    criticalAncestorPopulation: "Critical Ancestor Population",
    minimumNumberOfAncestorsRecords:
      "Número mínimo de registros de progenie del animal individual en el sistema necesario para lograr la precisión de la progenie (APD1) por encima del 50% (para la precisión del pedigrí)",
    forBirthWeightCG: "Para el peso al nacer CG",
    criticalPopulationInAnimalsContemporaryGroup:
      "Población crítica en el grupo contemporáneo del animal",
    minimumAverageNumberOfAnimalsPerBirthWeight:
      "Número promedio mínimo de animales por peso al nacer CG necesario para lograr una precisión promedio de CG (ACG3) por encima del 50%",
    criticalAveragePopulationPerContemporaryGroup:
      "Población promedio crítica por grupo contemporáneo",
    minimumNumberOfAnimalsInBirthWeight:
      "Número mínimo de animales en el peso al nacer del animal CG necesario para lograr la precisión de CG (ACG2) por encima del 50%",
    forWeaningWeightCG: "Para el peso de destete cg",
    minimumAverageNumberOfAnimalsPerWeaningWeight:
      "Número promedio mínimo de animales por peso de destete CG necesario para lograr una precisión promedio de CG (ACG3) por encima del 50%",
    minimumNumberOfAnimalsInWeaningWeight:
      "Número mínimo de animales en el peso de destete del animal CG necesario para lograr la precisión de CG (ACG2) por encima del 50%",
    forYearlingWeightCG: "Para el peso de un año CG",
    minimumAverageNumberOfAnimalsPerYearling:
      "Número promedio mínimo de animales por año CG necesario para lograr una precisión promedio de CG (ACG3) por encima del 50%",
    minimumNumberOfAnimalsInYearlingWeight:
      "Número mínimo de animales en el peso de un año del animal CG necesario para lograr la precisión de CG (ACG2) por encima del 50%",
    forCarcassCG: "Para carcass CG",
    minimumAverageNumberOfAnimalsPerCarcassWeight:
      "Número promedio mínimo de animales por cadáver CG necesario para lograr una precisión promedio de CG (ACG3) por encima del 50%",
    minimumNumberOFAnimalInCarcassWeight:
      "Número mínimo de animales en el CG CG del animal necesario para lograr la precisión de CG (ACG2) por encima del 50%",
    epdRequiredFieldSettings: "Configuración de campo requerida por EPD",
    pleaseSelectRequiredFieldsForCompleteEPD:
      "Seleccione los campos requeridos para un cálculo EPD completo",
    byDefault: "Por defecto",
    pleaseNoteThatUsersNotAbleToObtainFullEPD:
      "Nota: Tenga en cuenta que los usuarios no podrán obtener un cálculo de EPD completo si no proporcionan los campos de datos que marca según sea necesario.",
    pleaseNoteThatRequiredFieldParametersCannotBeChanged:
      "Nota: Tenga en cuenta que los parámetros de campo requeridos no se pueden cambiar ya que ya hay grupos contemporáneos contra parámetros anteriores.",
    noResultFound: "NO SE HAN ENCONTRADO RESULTADOS",
    next: "Próximo",
    cancel: "Cancelar",
    selectAnimal: "Seleccionar Animal",
    searchBy: "Búsqueda por",
    breed: "Criar",
    regDate: "Registro Fecha",
    status: "Estado",
    animalDetails: "Detalles de animales",
    add: "Agregar",
    update: "Actualizar",
    dataForEPDs: " Datos para EPD",
    basicInformation: "Información básica",
    birthWeightInformation: "Información sobre el peso al nacer",
    weaningWeightInformation: "Información sobre el peso al destete",
    yearlingWeightInformation: "Información sobre el peso al año",
    carcassWeightInformation: "Información sobre el peso de la canal",
    delete: "Borrar",
    deleteEpdData: "Eliminar datos de EPD",
    areYouSureYouWantToDeleteEpdData:
      "¿Está seguro de que desea eliminar los datos de EPD?",

    internationalID: "Identificación internacional",
    enterID: "Ingrese identificación",
    animalRegistration: "Registro de animales",
    location: "Ubicación",
    additionalIDMethod: "Método de identificación adicional",
    damID: "Identificación del Dam",
    sireID: "Identificación del padre",

    breederHerdCode: "Código de rebaño de criadores",
    birthYear: "Año de nacimiento",
    primaryBreed: "Raza primaria",
    breedComposition: "Composición de la raza",
    secondaryBreed: "Raza secundaria",
    seasonofBirth: "Temporada de Nacimiento",
    birthManagementCode: "Código de gestión de nacimientos",
    damAge: "Dam Edad",
    years: "Años",
    birthContemporaryCode: "Nacimiento Código Contemporáneo",
    accuracyWeight: "Precisión Peso",
    noteMinimumRequiredFieldForBirthWeight:
      "Nota: campo mínimo obligatorio para las DEP de peso al nacer, año de nacimiento, género, método de concepción, peso al nacer.",
    note: "Nota",
    minimumRequiredFieldForBirthWeight:
      "Campo mínimo obligatorio para las EPD de peso al nacer",
    birthYearGenderConceptionMethodBirthWeight:
      "Año de Nacimiento, Género, Método de Concepción, Peso al Nacer",

    weaningWeight: "Peso al destete",
    weaningDate: "Fecha de destete",
    weaningContemporaryGroupCode: "Destete Grupo Contemporáneo Código",
    creep: "Arrastrarse",
    managementPastureCode: "Código de manejo/pastos",
    weaningSex: "Sexo de destete",
    minimumRequiredFieldForWeaningWeight:
      "Campo mínimo obligatorio para las EPD de peso al destete",
    weaningWeightManagementPastureCodeWeaningSexDateWeighed:
      "Peso al destete, Código de manejo/pastoreo, Sexo al destete, Fecha de pesaje",

    yearlingWeight: "Peso al año",
    yearlingHeight: "Altura de un año",
    yearlingDate: "Fecha de nacimiento",
    yearlingContemporaryGroupCode: "Código de grupo contemporáneo de un año",
    managementFeedingCode: "Código de Manejo/Alimentación",
    yearlingSex: "Sexo de un año",
    youWillNeedToFillOutFor:
      "Deberá completar todos los campos para recuperar los datos de EPD para",

    pleaseSelectHavestDateFirstToEnterInfo:
      "Por favor seleccione 'Fecha de Cosecha' primero para ingresar información para el Área del Ojo de Costilla, Grosor de Grasa y Marmoleado",
    harvestDate: "Fecha de cosecha",
    dateOnFeed: "Fecha en alimentación",
    daysOnFeed: "Días en alimentación",
    gradingDate: "Grading Date",
    carcassSex: "Sexo en canal",
    carcassWeight: "Peso de la canal",
    carcassContemporary: "Carcasa Contemporánea",
    damBreed: "Raza madre",
    ribEyeArea: "Área del ojo de la costilla",
    ribEyeAreaContemporary: "Rib Eye Area Contemporáneo",
    fatThickness: "Espesor de grasa",
    fatThicknessContemporary: "Espesor de grasa Contemporáneo",
    marbling: "Jaspeado",
    marblingContemporary: "Marmoleado Contemporáneo",
    yieldGradeContemporary: "Rendimiento Grado Contemporáneo",
    animalsNotListedInContemporaryGroupsMsg:
      "Los animales no se han agregado a ningún grupo contemporáneo debido a la falta de información. Solicite la información que falta a los usuarios.",
    listOfUngroupedAnimals: "Lista de animales sin agrupar",
    submittingData: "Envío de datos",
    resendToUser: "Reenviar al usuario",
    submittingAnimalsInGroupMsg:
      "La presentación de sus animales en grupos. Espere por favor",
    pressingResetBtnMsg:
      "Al presionar el botón Restablecer, se iniciará un proceso para reasignar animales a sus grupos contemporáneos.",
    doYouWantToProceed: "¿Desea continuar?",
    systemMaintainanceModeMsg:
      'Al presionar el botón "Cambiar al modo de mantenimiento" se iniciará un proceso y su sistema entrará al “MODO DE MANTENIMIENTO” donde los EDP calculados en el RESET se mantendrán constantes para cada animal hasta el próximo RESET (que podría ser 1-6 meses de distancia).',
    errorFetchingContemporaryGrpMsg:
      "Error al obtener datos de grupos contemporáneos",
    deleteSuccess: "Eliminar éxito",
    deleteSuccessMsg: "Grupo contemporáneo eliminado con éxito.",
    deleteFailed: "Eliminar fallido",
    deleteFailedMsg: "Error al eliminar datos de grupos contemporáneos",
    deleteContemporaryGrpMsg:
      "¿Está seguro de que desea eliminar el grupo contemporáneo?",
    addBirthWeightData: "Agregar datos de peso al nacer",
    addWeaningWeightData: "Agregar datos de peso al destete",
    birthWeightContemporaryGroupCode:
      "Peso al nacer Código de grupo contemporáneo",
    dateWeighted: "Fecha ponderada",
    addYearlingWeightData: "Agregar datos de peso al año",
    addCarcassWeightData: "Agregar datos de peso de la canal",
    weaningOrYearlingContemporaryGroupCode:
      "Peso al destete o al año Código de grupo contemporáneo",
    deleteContemporaryGroupMsg:
      "¿Está seguro de que desea eliminar el grupo contemporáneo?",
    updateSuccessMsg: "Grupo contemporáneo actualizado con éxito.",
    errorMsg:
      "Algo salió mal. Por favor revise todos los valores cuidadosamente.",
    fetchErrorMsg:
      "Error al obtener los campos obligatorios para el rasgo seleccionado.",
    forMaintainanceMode: "Para el modo de mantenimiento",
    ancestorsWeightFactor: "Factor de peso de los antepasados",
    weightGivenToTheAncestorFactor:
      "Peso dado al factor antecesor en relación con el factor CG para el cálculo de EPD en el modo Mantenimiento. Si solo se necesita tener en cuenta el factor CG, el valor de este parámetro es 0. Inicialmente, se recomienda utilizar los valores predeterminados del sistema.",
    addEPDModelSettingsData: "Agregar datos de configuración del modelo EPD",
    minimumNumberOfAnimalsInContemporaryGroups:
      "Número mínimo de animales en grupos contemporáneos",
    enterNumberOfAnimals: "Ingrese el número de animales",
    areYouSureYouWantToChangeEPDCalculation:
      "¿Está seguro de que desea cambiar los campos de cálculo de EPD obligatorios?",
    weightOfAnimalAtBirth: "Peso del animal al nacer",
    seasonIsAPeriodOfYear:
      "Una estación es un período del año que se distingue por condiciones climáticas especiales.",
    codeOfBirthWeightContemporaryGroup:
      "Código del Grupo Contemporáneo de Peso al Nacer",
    weaningWeightOfCalf: "Peso al destete del ternero",
    dateAnimalWasWeaned: "La fecha en que el animal fue destetado",
    genderOfWeaningAnimal: "Sexo del animal de destete",
    yearlingWeightOfCalf: "Peso al año del ternero",
    dateAnimalWasWeighted: "La fecha en que se pesó el animal",
    yearledAnimalSex: "El sexo del animal que fue añorado",
    dateOfAnimalKilledForMeat: "Fecha del animal sacrificado para carne",
    addSuccessMsg: "Grupo contemporáneo añadido con éxito",
    traitH: "El rasgo para el cálculo de EPD.",
    searchByValue: "Ingrese el número de registro/tatuaje/nombre/etiqueta"
  },
};
